<template>
    <v-container fluid v-resize="onResize">
        <v-card class="card-container">
            <v-form ref="filterTransactionForm" lazy-validation>
                <v-card-title class="pa-0 mb-5">
                    <v-row no-gutters class="standard-row header-container" align="center">
                    <v-col v-if="windowSize.x >= 1240" cols="12" sm="12" md="3" lg="3">
                        <div class="d-flex align-center">
                            <span class="header-text mr-3">
                                CS to PO
                            </span>
                             <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" class="ml-2" text x-large rounded outlined style="border-color:#424747; width: 35px; justify-self: unset;" @click="goToDownloadReport()">
                                            <svg width="35" fill="#72a4b0" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" stroke="#367591" stroke-width="0.00512"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"></path></g></svg> 
                                        </v-btn>
                                    </template>
                                    <span class="font-theme">Download Report</span>
                                </v-tooltip>
                        </div>
                    </v-col>
                    <v-col v-else cols="12" sm="12" md="12" lg="12">
                            <div>
                                <span class="header-text">
                                    CS to PO
                                </span>
                                <span>
                                     <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" class="ml-2" text x-large rounded outlined style="border-color:#424747; width: 35px; justify-self: unset;" @click="goToDownloadReport()">
                                            <svg width="35" fill="#72a4b0" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" stroke="#367591" stroke-width="0.00512"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"></path></g></svg> 
                                        </v-btn>
                                    </template>
                                    <span class="font-theme">Download Report</span>
                                </v-tooltip>
                                </span>
                            </div>
                    </v-col>
                    <v-col v-if="windowSize.x >= 1240" cols="12" sm="12" md="4" lg="4" class="toggle-type-doc">
                             <v-row class="standard-row" >
                               <template>
                                    <v-card class="card-main-search " elevation="0">
                                        <v-tabs v-model="TapSearchDocumentType" hide-slider class="tab-type-search">
                                            <v-tab class="tab-search">SO</v-tab>
                                            <v-tab class="tab-search">CS</v-tab>
                                        </v-tabs>
                                        <v-card flat class="card-search-cs-po d-flex align-center px-2 py-1">
                                        <v-combobox
                                            v-model="searchDocumentType"
                                            :items="[]"
                                            placeholder="Search"
                                            outlined
                                            dense
                                            append-icon="mdi-magnify"
                                            multiple
                                            chips
                                            small-chips
                                            deletable-chips
                                            clearable
                                            hide-details
                                            hide-selected
                                            class="search-input-cs-so flex-grow-1"
                                            hide-no-data
                                            :disabled="!selectedButton || searchDocumentType.length > 20"
                                            :search-input.sync="searchInput"
                                            @beforeinput.native="handleBeforeInput"
                                            @keydown.native="handleSearchKeydown"
                                            @paste.native="handleSearchPaste"
                                            @click:append="filterTypeDoc"
                                            @click:clear="clearFilterTypeDoc"
                                        >
                                    <template v-slot:selection="{ attrs, item, parent }">
                                        <v-chip
                                            v-bind="attrs"
                                            small
                                            :class="getDocumentChipClass(item)"
                                            text-color="white"
                                            close
                                            @click:close="removeDocumentChip(item, parent)"
                                        >
                                            {{ item }}
                                        </v-chip>
                                    </template>         
                                    </v-combobox>            
                                        <v-tooltip top color="#1E293B">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    icon
                                                    small
                                                    class="ml-2 flex-shrink-0"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    color="#0EA5E9"
                                                >
                                                    <v-icon size="20">mdi-help-circle-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>กรอกหมายเลขแล้วกด Enter, Space, หรือ Comma (,) เพื่อเพิ่มหลายรายการ</span>
                                        </v-tooltip>
                                        </v-card> 
                                        <div v-if="searchDocumentType.length > 20" class="search-limit-text">
                                        ค้นหาได้สูงสุด 20 รายการ
                                        </div>
                                        <div v-else-if="searchDocumentType.length >= 1" class="search-limit-text-2">
                                            {{ searchDocumentType.length }} / 20
                                        </div> 
                                    </v-card>
                                </template>                             
                            </v-row>
                        </v-col>
                        <v-col v-else-if="windowSize.x  < 1240 && windowSize.x >= 750" cols="12" sm="4" md="4" lg="4">
                               <template>
                                    <v-card class="card-main-search" elevation="0">
                                        <v-tabs v-model="TapSearchDocumentType" hide-slider class="tab-type-search">
                                            <v-tab class="tab-search">SO</v-tab>
                                            <v-tab class="tab-search">CS</v-tab>
                                        </v-tabs>
                                        <v-card flat class="card-search-cs-po  d-flex align-center px-2 py-1">
                                           <v-combobox
                                            v-model="searchDocumentType"
                                            :items="[]"
                                            placeholder="Search"
                                            outlined
                                            append-icon="mdi-magnify"
                                            multiple
                                            chips
                                            small-chips
                                            deletable-chips
                                            clearable
                                            hide-details
                                            hide-selected
                                            class="search-input-cs-so flex-grow-1"
                                            hide-no-data
                                            :disabled="!selectedButton || searchDocumentType.length > 20"
                                            :search-input.sync="searchInput"
                                            @beforeinput.native="handleBeforeInput"
                                            @keydown.native="handleSearchKeydown"
                                            @paste.native="handleSearchPaste"
                                            @click:append="filterTypeDoc"
                                            @click:clear="clearFilterTypeDoc"
                                        >
                                        <template v-slot:selection="{ attrs, item, parent }">
                                            <v-chip
                                                v-bind="attrs"
                                                small
                                                :class="getDocumentChipClass(item)"
                                                text-color="white"
                                                close
                                                @click:close="removeDocumentChip(item, parent)"
                                            >
                                                {{ item }}
                                            </v-chip>
                                        </template>  
                                    </v-combobox>
                                        <v-tooltip top color="#1E293B">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        small
                                                        class="ml-2 flex-shrink-0"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        color="#0EA5E9"
                                                    >
                                                        <v-icon size="20">mdi-help-circle-outline</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>กรอกหมายเลขแล้วกด Enter, Space, หรือ Comma (,) เพื่อเพิ่มหลายรายการ</span>
                                            </v-tooltip>
                                        </v-card>
                                        <div v-if="searchDocumentType.length > 20" class="search-limit-text">
                                            ค้นหาได้สูงสุด 20 รายการ
                                        </div> 
                                        <div v-else-if="searchDocumentType.length >= 1" class="search-limit-text-2">
                                            {{ searchDocumentType.length }} / 20
                                        </div> 
                                    </v-card>
                                </template>
                        </v-col>
                        <v-col v-else cols="12" sm="12" md="12" lg="12">
                              <v-row class="standard-row" >
                                <template>
                                        <v-card class="card-main-search" elevation="0">
                                            <v-tabs v-model="TapSearchDocumentType" hide-slider class="tab-type-search">
                                                <v-tab class="tab-search">SO</v-tab>
                                                <v-tab class="tab-search">CS</v-tab>
                                            </v-tabs>
                                            <v-card flat class="card-search-cs-po  d-flex align-center px-2 py-1">
                                            <v-combobox
                                            v-model="searchDocumentType"
                                            :items="[]"
                                            placeholder="Search"
                                            outlined
                                            append-icon="mdi-magnify"
                                            multiple
                                            chips
                                            small-chips
                                            deletable-chips
                                            clearable
                                            hide-details
                                            hide-selected
                                            class="search-input-cs-so"
                                            hide-no-data
                                            :disabled="!selectedButton || searchDocumentType.length > 20"
                                            :search-input.sync="searchInput"
                                            @beforeinput.native="handleBeforeInput"
                                            @keydown.native="handleSearchKeydown"
                                            @paste.native="handleSearchPaste"
                                            @click:append="filterTypeDoc"
                                            @click:clear="clearFilterTypeDoc"
                                        >
                                        <template v-slot:selection="{ attrs, item, parent }">
                                            <v-chip
                                                v-bind="attrs"
                                                small
                                                :class="getDocumentChipClass(item)"
                                                text-color="white"
                                                close
                                                @click:close="removeDocumentChip(item, parent)"
                                            >
                                                {{ item }}
                                            </v-chip>
                                        </template>   
                                        </v-combobox>
                                            <v-tooltip top color="#1E293B">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        icon
                                                        small
                                                        class="ml-2 flex-shrink-0"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        color="#0EA5E9"
                                                    >
                                                        <v-icon size="20">mdi-help-circle-outline</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>กรอกหมายเลขแล้วกด Enter, Space, หรือ Comma (,) เพื่อเพิ่มหลายรายการ</span>
                                            </v-tooltip>
                                            </v-card>
                                        </v-card>
                                    </template>
                                </v-row>
                                <div v-if="searchDocumentType.length > 20" class="search-limit-text">
                                     ค้นหาได้สูงสุด 20 รายการ
                                </div> 
                        </v-col>
                         <v-col v-if="windowSize.x >= 1240" cols="12" sm="5" md="5" lg="5" class="d-flex justify-end">
                            <template>
                                <div  style="justify-self: end;">
                                    <v-btn  v-if="selectedButton === 'SO'" rounded elevation="1" color="#e0e0e0" style="background: linear-gradient(135deg, #eeeeee,#e0e0e0);" class="download-button-cs-po mr-2" height="46" width="130" @click="confirmCreateCStoPO('WaitQT')">
                                        <v-icon color="#1976D2" style="margin-right:3px;">
                                             mdi-information-outline
                                        </v-icon>
                                      <span>Wait QT</span> 
                                    </v-btn>
                                    <v-btn rounded elevation="1" color="#e0e0e0" style="background: linear-gradient(135deg, #eeeeee,#e0e0e0);" class="download-button-cs-po mr-2" height="46" width="130" @click="confirmCreateCStoPO('SaveCsToPo')">
                                        <v-icon color="#1976D2" style="margin-right:3px;">
                                            mdi-information-outline
                                        </v-icon>
                                       <span>บันทึก</span> 
                                    </v-btn>
                                    <v-btn rounded elevation="1" color="#1677FF" style="background: linear-gradient(135deg, #0EA5E9, #4F46E5);" class="white--text download-button-cs-po" height="46" width="130" @click="confirmCreateCStoPO('RunPo')">
                                        <v-icon color="#ffffff"  style="margin-right:3px;">
                                            mdi-export
                                        </v-icon>
                                        <span>RUN PO</span>
                                    </v-btn>
                                </div>
                            </template>
                        </v-col>
                        <v-col v-else-if="windowSize.x  <= 1239 && windowSize.x >= 750"  class="d-flex justify-end">
                            <template>
                                <div  style="justify-self: end;">
                                    <v-btn v-if="selectedButton === 'SO'" rounded elevation="1" color="#e0e0e0" style="background: linear-gradient(135deg, #eeeeee,#e0e0e0);" class="download-button-cs-po mr-2" height="40" width="130" @click="confirmCreateCStoPO('WaitQT')">
                                        <v-icon color="#1976D2" style="margin-right:3px;">
                                             mdi-information-outline
                                        </v-icon>
                                        <span>Wait QT</span>
                                    </v-btn>
                                    <v-btn rounded elevation="1" color="#e0e0e0" style="background: linear-gradient(135deg, #eeeeee,#e0e0e0);" class="download-button-cs-po mr-2" height="40" width="130" @click="confirmCreateCStoPO('SaveCsToPo')">
                                        <v-icon color="#1976D2" style="margin-right:3px;">
                                            mdi-information-outline
                                        </v-icon>
                                        <span>บันทึก</span>
                                    </v-btn>
                                    <v-btn rounded elevation="1" color="#1677FF" style="background: linear-gradient(135deg, #0EA5E9, #4F46E5);" class="white--text download-button-cs-po" height="40" width="130" @click="confirmCreateCStoPO('RunPo')">
                                        <v-icon color="#ffffff"  style="margin-right:3px;">
                                            mdi-export
                                        </v-icon>
                                        <span>RUN PO</span>
                                    </v-btn>
                                </div>
                            </template>
                    </v-col>
                    <v-col v-else  class="d-flex justify-start">
                            <template>
                                <div  style="justify-self: end;">
                                    <v-btn v-if="selectedButton === 'SO'" rounded elevation="1" color="#e0e0e0" style="background: linear-gradient(135deg, #eeeeee,#e0e0e0);" class="download-button-cs-po-small mr-2" height="40" width="130" @click="confirmCreateCStoPO('WaitQT')">
                                        <v-icon color="#1976D2" style="margin-right:3px;">
                                             mdi-information-outline
                                        </v-icon>
                                        Wait QT
                                    </v-btn>
                                    <v-btn rounded elevation="1" color="#e0e0e0" style="background: linear-gradient(135deg, #eeeeee,#e0e0e0);" class="download-button-cs-po-small mr-2" height="40" width="130" @click="confirmCreateCStoPO('SaveCsToPo')">
                                        <v-icon color="#1976D2" style="margin-right:3px;">
                                            mdi-information-outline
                                        </v-icon>
                                        บันทึก
                                    </v-btn>
                                    <v-btn rounded elevation="1" color="#1677FF" style="background: linear-gradient(135deg, #0EA5E9, #4F46E5);" class="white--text download-button-cs-po" height="40" width="130" @click="confirmCreateCStoPO('RunPo')">
                                        <v-icon color="#ffffff"  style="margin-right:3px;">
                                            mdi-export
                                        </v-icon>
                                        <span>RUN PO</span>
                                    </v-btn>
                                </div>
                            </template>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-divider v-if="windowSize.x < 850"></v-divider>
                <v-row no-gutters class="standard-row">
                    <v-data-table
                        fixed-header
                        dense
                        disable-sort
                        :headers="currentHeaders"
                        :items="itemsDataTable"
                        :server-items-length="countTransaction"
                        class="data-table-create-cspo"
                        :options.sync="optionsTransaction"
                        mobile-breakpoint="600"
                        
                        :footer-props="{ 'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text': 'จำนวนแถวต่อหน้า' }"
                    >
                        <template v-slot:body="{ items, isMobile }">
                            <tbody v-if="items.length && !isMobile">
                                <tr v-for="(body, indexBody) in items" :key="indexBody" class="get-element-tr-create-cspo">
                                   <td v-if="TapSearchDocumentType === 0" valign="top" align="center" class="sticky-table sticky-table--sale-document">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 close-expand-icon">
                                                    <v-row
                                                        class="text-center standard-row each-header-row-expand-table"
                                                        no-gutters
                                                        style="height: auto; line-height: 20px;"
                                                        justify="center"
                                                        align="center"
                                                    >
                                                    {{ body.expanded[0].sale_document }}
                                                    </v-row>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                            {{ itemExpand.sale_document }}
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" class="sticky-table" :class="TapSearchDocumentType === 1 ? 'sticky-table--document-id' : 'sticky-table--document-id-so'">
                                        <v-expansion-panels v-show="body.expanded.length" class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel @click.native="handleExpandDocID(indexBody)">
                                                <v-expansion-panel-header class="pa-0 expand-header-document-id" expand-icon="mdi-menu-down">
                                                    <v-row v-if = "TapSearchDocumentType === 1"
                                                        class="text-center standard-row each-header-row-expand-table"
                                                        no-gutters
                                                        style="height: auto; line-height: 20px;"
                                                        justify="center"
                                                        align="center"
                                                    >
                                                      {{ body.expanded[0].document_id }} 
                                                    </v-row>                                              
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                            {{ itemExpand.document_id }}
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                            <v-tooltip top :disabled="!itemExpand.job_status || itemExpand.job_status === '-'">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span v-bind="attrs" v-on="on" class="text-limit-length">
                                                                {{ itemExpand.job_status }}
                                                                </span>
                                                                </template>
                                                                <span>{{ itemExpand.job_status }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td v-if="TapSearchDocumentType === 0" valign="top">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                            <v-tooltip top :disabled="!itemExpand.terminate || itemExpand.terminate === '-'">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span v-bind="attrs" v-on="on" class="text-limit-length">
                                                                {{ itemExpand.terminate }}
                                                                </span>
                                                                </template>
                                                                <span>{{ itemExpand.terminate }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td v-if="TapSearchDocumentType === 0" valign="top">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                           <v-tooltip top :disabled="!itemExpand.terminate_date || itemExpand.terminate_date === '-'">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <span v-bind="attrs" v-on="on" class="text-limit-length" >
                                                                    {{ itemExpand.terminate_date }}
                                                                </span>
                                                            </template>
                                                            <span>{{ itemExpand.terminate_date }}</span>
                                                        </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                            <v-tooltip top :disabled="!itemExpand.job_ref_no || itemExpand.job_ref_no === '-'">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span v-bind="attrs" v-on="on" class="text-limit-length">
                                                                        {{ itemExpand.job_ref_no }}
                                                                    </span>
                                                                </template>
                                                                <span>{{ itemExpand.job_ref_no }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                            <v-tooltip top :disabled="!itemExpand.group_service || itemExpand.group_service === '-'">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span v-bind="attrs" v-on="on" class="text-limit-length">
                                                                        {{ itemExpand.group_service }}
                                                                    </span>
                                                                </template>
                                                                <span>{{ itemExpand.group_service }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                            <v-tooltip top :disabled="!itemExpand.service_name || itemExpand.service_name === '-'">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span v-bind="attrs" v-on="on" class="text-limit-length">
                                                                        {{ itemExpand.service_name }}
                                                                    </span>
                                                                </template>
                                                                <span>{{ itemExpand.service_name }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">

                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                            justify="center"
                                                        >
                                                            <v-tooltip top :disabled="!itemExpand.unit || itemExpand.unit === '-'">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span v-bind="attrs" v-on="on" class="text-limit-length">
                                                                        {{ itemExpand.unit }}
                                                                     </span>
                                                                </template>
                                                                <span>{{ itemExpand.unit }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                            <v-tooltip top :disabled="!itemExpand.unit_type || itemExpand.unit_type === '-'">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span v-bind="attrs" v-on="on" class="text-limit-length">
                                                                        {{ itemExpand.unit_type }}
                                                                    </span>
                                                                </template>
                                                                <span>{{ itemExpand.unit_type }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                            <v-tooltip top :disabled="!itemExpand.start_date_filter || itemExpand.start_date_filter === '-'">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span v-bind="attrs" v-on="on" class="text-limit-length">
                                                                        {{ itemExpand.start_date_filter }}
                                                                    </span>
                                                                </template>
                                                                <span>{{ itemExpand.start_date_filter }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                            <v-tooltip top :disabled="!itemExpand.end_date_filter || itemExpand.end_date_filter === '-'">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span v-bind="attrs" v-on="on" class="text-limit-length">
                                                                        {{ itemExpand.end_date_filter }}
                                                                    </span>
                                                                </template>
                                                                <span>{{ itemExpand.end_date_filter }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td v-if="TapSearchDocumentType === 1" valign="top" align="center">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                        <v-tooltip top :disabled="!itemExpand.remark || itemExpand.remark === '-'">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <span v-bind="attrs" v-on="on" class="text-limit-length">
                                                                {{ itemExpand.remark }}
                                                                </span>
                                                            </template>
                                                            <span>{{ itemExpand.remark }}</span>
                                                        </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center" class="sticky-table" :class="TapSearchDocumentType === 1 ? 'sticky-table--actual' : 'sticky-table--actual-so'">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                            {{ itemExpand.actual }}
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center" class="sticky-table" :class="TapSearchDocumentType === 1 ? 'sticky-table--file' : 'sticky-table--file-so'">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 close-expand-icon">
                                                    <v-row
                                                    no-gutters
                                                    class="text-center standard-row each-header-row-expand-table"
                                                    style="height: auto; line-height: 20px;"
                                                    justify="center"
                                                    align="center"
                                                    >
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon elevation="0" depressed v-bind="attrs" v-on="on" small color="#808080" :disabled="!body.expanded.length" @click.native="$event.cancelBubble = true" @click="openAttachedFileList(body.expanded[0])">
                                                                <svg xmlns="http://www.w3.org/2000/svg" style="color:#7f7d7d;" width="20" height="20"
                                                                    fill="currentColor" class="bi bi-file-earmark-fill" viewBox="0 0 16 16">
                                                                    <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z" />
                                                                </svg>
                                                            </v-btn>
                                                        </template>
                                                        <span class="font-theme">ดูเอกสาร</span>
                                                    </v-tooltip>
                                                    </v-row>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <div
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            justify="center"
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                        >
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    icon
                                                                    elevation="0"
                                                                    depressed
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    small
                                                                    :disabled="TapSearchDocumentType === 1 &&!(itemExpand.approver_cs &&String(itemExpand.approver_cs).trim() !== '-' ) &&
                                                                    !(itemExpand.add_qt?.approver_cs && String(itemExpand.add_qt.approver_cs).trim() !== '-')"
                                                                    :color="itemExpand.add_qt ? '#FF4D4F' : '#1877FF'"
                                                                    @click="addAndDeleteQt(indexBody, indexExpand, itemExpand.add_qt ? 'delete' : 'add')"
                                                                >
                                                                        <v-icon size="20">
                                                                            {{ itemExpand.add_qt ? 'mdi-minus-circle' : 'mdi-plus-circle' }}
                                                                        </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span class="font-theme">{{ itemExpand.add_qt ? 'ลบ ' : 'เพิ่ม ' }}QT</span>
                                                        </v-tooltip>
                                                        </div>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center" class="sticky-table"  :class="TapSearchDocumentType === 1 ? 'sticky-table--vendor-name' : 'sticky-table--vendor-name-so'">
                                        <v-expansion-panels class="expansion-cs-list-action" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 close-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-if="body.open_expanded === 0"
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                            justify="center"
                                                        >
                                                        <v-tooltip top :disabled="!itemExpand.vendor?.vendor_name_th">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-autocomplete
                                                                v-model="itemExpand.vendor" 
                                                                outlined 
                                                                dense
                                                                v-on="on"
                                                                v-bind="attrs"
                                                                hide-details
                                                                :items=vendorList
                                                                item-text="vendor_name_th"
                                                                class="vendor-name-autocomplete" 
                                                                :menu-props="{ bottom: true, offsetY: true }"
                                                                return-object
                                                                :disabled="TapSearchDocumentType === 1 && !(itemExpand.approver_cs !== undefined && itemExpand.approver_cs !== null && String(itemExpand.approver_cs).trim() !== '' && String(itemExpand.approver_cs).trim() !== '-') && !(itemExpand.add_qt?.approver_cs !== undefined && itemExpand.add_qt?.approver_cs !== null && String(itemExpand.add_qt.approver_cs).trim() !== '' && String(itemExpand.add_qt.approver_cs).trim() !== '-')"                                                           
                                                                @change="subGroupCheckboxChanged(body.expanded, itemExpand)"
                                                            > 
                                                            <template v-slot:item="data">
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 10px;">{{ data.item.vendor_name_th }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </template>
                                                            <template v-slot:no-data>
                                                                <v-list-item>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 10px;">ไม่พบข้อมูล</v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </template>
                                                            </v-autocomplete>
                                                            </template>
                                                            <span>{{ itemExpand.vendor?.vendor_name_th }}</span>
                                                            </v-tooltip>
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center" class="sticky-table" :class="TapSearchDocumentType === 1 ? 'sticky-table--qt-vendor' : 'sticky-table--qt-vendor-so'">
                                        <v-expansion-panels class="expansion-cs-list-action" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 close-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-if="body.open_expanded === 0"
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                            justify="center"
                                                        >
                                                        <v-tooltip top :disabled="!itemExpand.qt_vendor">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field 
                                                            v-model="itemExpand.qt_vendor" 
                                                            v-on="on"
                                                            v-bind="attrs"
                                                            outlined 
                                                            dense
                                                            hide-details
                                                            :disabled="TapSearchDocumentType === 1 && !(itemExpand.approver_cs !== undefined && itemExpand.approver_cs !== null && String(itemExpand.approver_cs).trim() !== '' && String(itemExpand.approver_cs).trim() !== '-') && !(itemExpand.add_qt?.approver_cs !== undefined && itemExpand.add_qt?.approver_cs !== null && String(itemExpand.add_qt.approver_cs).trim() !== '' && String(itemExpand.add_qt.approver_cs).trim() !== '-')"                                                           
                                                            @input="subGroupCheckboxChanged(body.expanded, itemExpand)"
                                                            > 
                                                            </v-text-field>
                                                        </template>
                                                        <span>{{ itemExpand.qt_vendor }}</span>
                                                        </v-tooltip>
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center" class="sticky-table" :class="TapSearchDocumentType === 1 ? 'sticky-table--qt-value' : 'sticky-table--qt-value-so'">
                                        <v-expansion-panels class="expansion-cs-list-action" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-if="body.open_expanded === 0"
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                            justify="center"
                                                        >
                                                        <v-tooltip top :disabled="!itemExpand.qt_value">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field 
                                                            v-model="itemExpand.qt_value"
                                                            v-on="on"
                                                            v-bind="attrs"
                                                            outlined 
                                                            dense
                                                            hide-details 
                                                            @change="subGroupCheckboxChanged(body.expanded, itemExpand)"
                                                            type="text"
                                                            hide-spin-buttons
                                                            :disabled="TapSearchDocumentType === 1 && !(itemExpand.approver_cs !== undefined && itemExpand.approver_cs !== null && String(itemExpand.approver_cs).trim() !== '' && String(itemExpand.approver_cs).trim() !== '-') && !(itemExpand.add_qt?.approver_cs !== undefined && itemExpand.add_qt?.approver_cs !== null && String(itemExpand.add_qt.approver_cs).trim() !== '' && String(itemExpand.add_qt.approver_cs).trim() !== '-')"
                                                            v-currency="currencyConfig()"
                                                            :error="validateQtAndDiscount(itemExpand).isInvalid"
                                                            :error-messages="validateQtAndDiscount(itemExpand).isInvalid ? 'Discount มากเกินไป' : ''"
                                                            > 
                                                            </v-text-field>
                                                            </template>
                                                            <span>{{ itemExpand.qt_value }}</span>
                                                        </v-tooltip>
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center" class="sticky-table" :class="TapSearchDocumentType === 1 ? 'sticky-table--discount' : 'sticky-table--discount-so'">
                                        <v-expansion-panels class="expansion-cs-list-action" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 hide-expand-icon">
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-if="body.open_expanded === 0"
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                            justify="center"
                                                        >
                                                        <v-tooltip top :disabled="!itemExpand.discount">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field 
                                                            v-model="itemExpand.discount"
                                                            v-on="on"
                                                            v-bind="attrs"
                                                            outlined 
                                                            dense
                                                            v-currency="currencyConfig()"
                                                            hide-details 
                                                            @change="subGroupCheckboxChanged(body.expanded, itemExpand)"
                                                            :error="validateQtAndDiscount(itemExpand).isInvalid"
                                                            :error-messages="validateQtAndDiscount(itemExpand).isInvalid ? 'Discount มากเกินไป' : ''"
                                                            :disabled="TapSearchDocumentType === 1 && !(itemExpand.approver_cs !== undefined && itemExpand.approver_cs !== null && String(itemExpand.approver_cs).trim() !== '' && String(itemExpand.approver_cs).trim() !== '-') && !(itemExpand.add_qt?.approver_cs !== undefined && itemExpand.add_qt?.approver_cs !== null && String(itemExpand.add_qt.approver_cs).trim() !== '' && String(itemExpand.add_qt.approver_cs).trim() !== '-')"
                                                            type="text"
                                                            hide-spin-buttons
                                                            > 
                                                            </v-text-field>
                                                            </template>
                                                            <span>{{ itemExpand.discount }}</span>
                                                        </v-tooltip>
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td v-if="TapSearchDocumentType === 1" valign="top" align="center" class="sticky-table sticky-table--approver">
                                         <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 close-expand-icon"></v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                    <v-row 
                                                        :key="`${indexExpand}`" 
                                                        class="text-center standard-row cell-class-expand-table" 
                                                        :name="`doc_id_${indexBody}`" 
                                                        no-gutters 
                                                        :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'" 
                                                        justify="center"
                                                    >
                                                        <v-btn v-if="((itemExpand.approver_cs !== undefined && itemExpand.approver_cs !== null && String(itemExpand.approver_cs).trim() !== '' && String(itemExpand.approver_cs).trim() !== '-') || (itemExpand.add_qt?.approver_cs !== undefined && itemExpand.add_qt?.approver_cs !== null && String(itemExpand.add_qt.approver_cs).trim() !== '' && String(itemExpand.add_qt.approver_cs).trim() !== '-'))" icon x-small elevation="0" depressed class="approver-plus-btn" @click.stop.prevent="approverDialogOpen(itemExpand)" :disabled="TapSearchDocumentType === 1 && !!(itemExpand.add_qt?.approver_cs || itemExpand.approver_cs)">
                                                            <v-icon size="19" color="#72d572">mdi-checkbox-marked-circle-outline</v-icon>
                                                        </v-btn>

                                                        <v-btn v-else icon x-small elevation="0" depressed class="approver-plus-btn" @click.stop.prevent="approverDialogOpen(itemExpand)">
                                                            <v-icon size="22" color="#1877FF" :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'">mdi-plus-circle-outline</v-icon>
                                                        </v-btn>

                                                        <v-tooltip v-if="((itemExpand.approver_cs !== undefined && itemExpand.approver_cs !== null && String(itemExpand.approver_cs).trim() !== '' && String(itemExpand.approver_cs).trim() !== '-') || (itemExpand.add_qt?.approver_cs !== undefined && itemExpand.add_qt?.approver_cs !== null && String(itemExpand.add_qt.approver_cs).trim() !== '' && String(itemExpand.add_qt.approver_cs).trim() !== '-'))" top content-class="approver-tooltip" :open-delay="200"> 
                                                            <template v-slot:activator="{ on, attrs }"> 
                                                                <div v-bind="attrs" v-on="on" class="approver-name">{{ itemExpand.approver_cs || itemExpand.add_qt?.approver_cs }}</div> 
                                                            </template> 
                                                            <span>{{ itemExpand.approver_cs || itemExpand.add_qt?.approver_cs }}</span> 
                                                        </v-tooltip>
                                                    </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                    <td valign="top" align="center" class="sticky-table" :class="TapSearchDocumentType === 1 ? 'sticky-table--checkbox' : 'sticky-table--checkbox-so'">
                                        <v-expansion-panels class="expansion-cs-list" v-model="body.open_expanded">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header class="pa-0 close-expand-icon">
                                                    <v-row
                                                        class="text-center standard-row each-header-row-expand-table"
                                                        no-gutters
                                                        style="height: auto; line-height: 20px;"
                                                        justify="center"
                                                        align="center"
                                                    >
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn v-on="on" icon elevation="0" v-bind="attrs" depressed small color="#808080" :disabled="!body.expanded.length" @click.native="$event.cancelBubble = true">
                                                                <v-checkbox v-if="TapSearchDocumentType === 0" v-model="selectedGroups[body.sale_document]" @change="groupCheckboxChanged(body)" color="#00AA1B"
                                                                    on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank">
                                                                </v-checkbox>
                                                                <v-checkbox v-else v-model="selectedGroups[body.expanded[0].document_id]" @change="groupCheckboxChanged(body)" color="#00AA1B"
                                                                    on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank"   :disabled="!body.expanded ||!body.expanded.length || body.expanded.every(item =>!item.approver_cs ||item.approver_cs === '-')">
                                                                </v-checkbox>
                                                            </v-btn>
                                                        </template>
                                                        <span class="font-theme">เลือกเอกสาร</span>
                                                    </v-tooltip>
                                                    </v-row>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <template v-for="(itemExpand, indexExpand) in body.expanded">
                                                        <v-row
                                                            v-if="body.open_expanded === 0"
                                                            :key="`${indexExpand}`"
                                                            class="text-center standard-row cell-class-expand-table"
                                                            :name="`doc_id_${indexBody}`"
                                                            no-gutters
                                                            :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                            justify="center"
                                                        >
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon elevation="0" depressed v-bind="attrs" v-on="on" small color="#808080" :disabled="!body.expanded.length">
                                                                    <v-checkbox  v-if ="TapSearchDocumentType === 0" v-model="selectedSubGroups[itemExpand._id]" color="#00AA1B"
                                                                        on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank" @change="subGroupCheckboxChanged(body.expanded, itemExpand)">
                                                                    </v-checkbox>
                                                                    <v-checkbox  v-if="TapSearchDocumentType === 1" v-model="selectedSubGroups[itemExpand._id]" color="#00AA1B" :disabled="TapSearchDocumentType === 1 && !(itemExpand.approver_cs !== undefined && itemExpand.approver_cs !== null && String(itemExpand.approver_cs).trim() !== '' && String(itemExpand.approver_cs).trim() !== '-') && !(itemExpand.add_qt?.approver_cs !== undefined && itemExpand.add_qt?.approver_cs !== null && String(itemExpand.add_qt.approver_cs).trim() !== '' && String(itemExpand.add_qt.approver_cs).trim() !== '-')"
                                                                        on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank" @change="subGroupCheckboxChanged(body.expanded, itemExpand)">
                                                                    </v-checkbox>
                                                                </v-btn>
                                                            </template>
                                                            <span class="font-theme">เลือกเอกสาร</span>
                                                        </v-tooltip>
                                                        </v-row>
                                                    </template>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else-if="items.length && isMobile">
                                <tr v-for="(_, indexBody) in items" :key="indexBody" class="table-row-mobile">
                                    <v-row no-gutters class="standard-row ml-1" justify="space-between" align="center">
                                        <v-btn icon elevation="0" depressed small color="#808080" :disabled="!items[indexBody].expanded.length" @click.native="$event.cancelBubble = true">
                                            <v-checkbox v-model="selectedGroups[items[indexBody].sale_document]" @change="groupCheckboxChanged(items[indexBody])" color="#00AA1B"
                                                on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank">
                                            </v-checkbox>
                                        </v-btn>
                                    </v-row>
                                    <v-row no-gutters class="standard-row" justify="space-between">
                                        <v-col cols="auto" sm="auto" class="pr-1">
                                            Sale Document
                                        </v-col>
                                        <v-col cols="auto" sm="auto" class="pl-1">
                                            <v-row
                                                no-gutters
                                                class="standard-row"
                                            >
                                                {{ items[indexBody].sale_document}}
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                        <span>File</span>
                                        <span>
                                            <v-btn icon elevation="0" depressed small color="#808080" :disabled="!items[indexBody].expanded.length" @click.native="$event.cancelBubble = true" @click="openAttachedFileList(items[indexBody])">
                                                <svg xmlns="http://www.w3.org/2000/svg" style="color:#7f7d7d;" width="20" height="20"
                                                    fill="currentColor" class="bi bi-file-earmark-fill" viewBox="0 0 16 16">
                                                    <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z" />
                                                </svg>
                                            </v-btn>
                                        </span>
                                    </v-row>
                                    <v-row v-if="items[indexBody].expanded.length" no-gutters class="standard-row" justify="space-between" align="center">
                                        <v-expansion-panels class="expand-table-mobile">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header expand-icon="mdi-menu-down">
                                                    Detail
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content class="expansion-expanded">
                                                    <v-row
                                                        no-gutters
                                                        class="standard-row"
                                                        v-for="(itemExpand, indexExpand) in items[indexBody].expanded"
                                                        :key="indexExpand"
                                                    >
                                                        <!-- <v-row
                                                         :class="indexExpand % 2 === 0 ? 'expansion-expanded-even': 'expansion-expanded-odd'"
                                                            no-gutters
                                                            class="standard-row pt-2"
                                                            v-for="(csList, indexCS) in itemExpand"
                                                            :key="indexCS"
                                                        > -->
                                                            <hr style="width:100%;">
                                                            <v-row no-gutters class="standard-row ml-1" justify="space-between" align="center">
                                                                <v-btn icon elevation="0" depressed small color="#808080" @click.native="$event.cancelBubble = true">
                                                                    <v-checkbox v-model="selectedSubGroups[itemExpand._id]" @change="subGroupCheckboxChanged(items[indexBody].expanded, itemExpand)" color="#00AA1B"
                                                                        on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank">
                                                                    </v-checkbox>
                                                                </v-btn>
                                                            </v-row>
                                                            <template v-if="!itemExpand.add_qt">
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Sale Document
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.sale_document }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Document ID
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.document_id }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Job Status
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.job_status }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Terminate Doc
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.terminate }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Terminate Date
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.terminate_date }}
                                                                </v-col>
                                                            </v-row>
                                                             <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Job Ref
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.job_ref_no }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Group Service
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.group_service }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Service Name
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.service_name }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Unit
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.unit }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Unit Type
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.unit_type }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Start Date
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.start_date_filter }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    End Date
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.end_date_filter }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    Actual
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="pl-1">
                                                                    {{ itemExpand.actual }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row no-gutters class="standard-row" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    File
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="mb-1">
                                                                     <v-tooltip top>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-btn icon elevation="0" depressed v-bind="attrs" v-on="on" small color="#808080" :disabled="!itemExpand.length" @click.native="$event.cancelBubble = true" @click="openAttachedFileList(itemExpand)">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" style="color:#7f7d7d;" width="20" height="20"
                                                                                    fill="currentColor" class="bi bi-file-earmark-fill" viewBox="0 0 16 16">
                                                                                    <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z" />
                                                                                </svg>
                                                                            </v-btn>
                                                                        </template>
                                                                        <span class="font-theme">ดูเอกสาร</span>
                                                                    </v-tooltip>
                                                                </v-col>
                                                            </v-row> 
                                                            </template>
                                                             <v-row no-gutters class="standard-row" justify="space-between"
                                                            align="center">
                                                            <v-col cols="auto" sm="auto" class="pr-1">
                                                                Vendor Name
                                                            </v-col>
                                                            <v-col cols="auto" sm="auto" class="mb-1">
                                                                <v-autocomplete v-model="itemExpand.vendor" outlined
                                                                    dense hide-details :items=vendorList
                                                                    item-text="vendor_name_th"
                                                                    class="vendor-name-autocomplete"
                                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                                    return-object
                                                                    @change="subGroupCheckboxChanged(items[indexBody].expanded, itemExpand)">
                                                                </v-autocomplete>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters class="standard-row" justify="space-between"
                                                            align="center">
                                                            <v-col cols="auto" sm="auto" class="pr-1">
                                                                QT Vendor
                                                            </v-col>
                                                            <v-col cols="auto" sm="auto" class="mb-1">
                                                                <v-tooltip top :disabled="!itemExpand.vendor">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-text-field 
                                                                        v-model="itemExpand.qt_vendor" 
                                                                        v-on="on"
                                                                        v-bind="attrs"
                                                                        outlined 
                                                                        dense
                                                                        hide-details
                                                                        @change="subGroupCheckboxChanged(items[indexBody].expanded, itemExpand)"
                                                                        > 
                                                                        </v-text-field>
                                                                    </template>
                                                                    <span>{{ itemExpand.qt_vendor }}</span>
                                                                </v-tooltip>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters class="standard-row" justify="space-between"
                                                            align="center">
                                                            <v-col cols="auto" sm="auto" class="pr-1">
                                                                QT Value
                                                            </v-col>
                                                            <v-col cols="auto" sm="auto" class="mb-1">
                                                                <v-tooltip top :disabled="!itemExpand.qt_value">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-text-field v-model="itemExpand.qt_value"
                                                                            v-on="on" v-bind="attrs" outlined dense
                                                                            hide-details
                                                                            @change="subGroupCheckboxChanged(items[indexBody].expanded, itemExpand)"
                                                                            type="text" hide-spin-buttons
                                                                            v-currency="currencyConfig()"
                                                                            :error="validateQtAndDiscount(itemExpand).isInvalid"
                                                                            :error-messages="validateQtAndDiscount(itemExpand).isInvalid ? 'Discount มากเกินไป' : ''">
                                                                        </v-text-field>
                                                                    </template>
                                                                    <span>{{ itemExpand.qt_value }}</span>
                                                                </v-tooltip>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row no-gutters class="standard-row" justify="space-between"
                                                            align="center">
                                                            <v-col cols="auto" sm="auto" class="pr-1">
                                                                ส่วนลด
                                                            </v-col>
                                                            <v-col cols="auto" sm="auto" class="mb-1">
                                                                <v-tooltip top :disabled="!itemExpand.discount">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-text-field v-model="itemExpand.discount"
                                                                            v-on="on" v-bind="attrs" outlined dense
                                                                            v-currency="currencyConfig()" hide-details
                                                                            @change="subGroupCheckboxChanged(items[indexBody].expanded, itemExpand)"
                                                                            :error="validateQtAndDiscount(itemExpand).isInvalid"
                                                                            :error-messages="validateQtAndDiscount(itemExpand).isInvalid ? 'Discount มากเกินไป' : ''"
                                                                            type="text" hide-spin-buttons>
                                                                        </v-text-field>
                                                                    </template>
                                                                    <span>{{ itemExpand.discount }}</span>
                                                                </v-tooltip>
                                                            </v-col>
                                                        </v-row>
                                                            <v-row no-gutters class="standard-row pb-2" justify="space-between" align="center">
                                                                <v-col cols="auto" sm="auto" class="pr-1">
                                                                    {{ itemExpand.add_qt ? 'ลบ QT' : 'เพิ่ม QT' }}
                                                                </v-col>
                                                                <v-col cols="auto" sm="auto" class="mb-1">
                                                                    <v-btn
                                                                        icon
                                                                        elevation="0"
                                                                        depressed
                                                                        small
                                                                        @click="addAndDeleteQt(indexBody, indexExpand, itemExpand.add_qt ? 'delete' : 'add')"
                                                                    >
                                                                        <v-icon dark color="#A8A8A8">
                                                                            {{ itemExpand.add_qt ? 'mdi-minus-circle' : 'mdi-plus-circle' }}
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        <!-- </v-row> -->
                                                    </v-row>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-row>
                                </tr>
                            </tbody>
                            <tbody v-else-if="!items.length && !isMobile">
                                <tr v-for="(_, index_tr) in (20 - itemsDataTable.length)" :key="`tr__${index_tr}`" style="height: 35px;">
                                    <td colspan="14">
                                        <v-row
                                            v-if="!index_tr"
                                            no-gutters
                                            class="standard-row font-theme"
                                            align="center"
                                            justify="center"
                                            style="font-size: 12px; font-weight: 500;"
                                        >
                                            {{ callApiPending === 0 ? 'ไม่พบข้อมูล' : null}}
                                        </v-row>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr class="empty-text-table text-center">
                                    ไม่พบข้อมูล
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>
                </v-row>
            </v-form>
        </v-card>
        <!-- <saveBudgetModal /> -->
        <DownloadReportModal />
        <CancelSaveBudgetList />
        <DownloadAttachFile/>
        <ConfirmApproverCStoPO ref="approverDialog" />
        <ConfirmCreateCStoPO ref="confirmDialog" />
    </v-container>
</template>

<script>
import { EventBus } from '../EventBus';
import { nextTick } from 'vue'
import { MainFunction } from '@/functions/mainFunction.js'
// import saveBudgetModal from '../components/saveBudgetModal.vue'
import DownloadReportModal from '../components/DownloadReportModal.vue'
import CancelSaveBudgetList from '../components/CancelSaveBudgetList.vue'
import ConfirmCreateCStoPO from '../components/ConfirmCreateCStoPO.vue';
import ConfirmApproverCStoPO from '../components/ApproverCstoPo.vue';
import DownloadAttachFile from "../components/DownloadAttachFile.vue";
import { validateQtAndDiscount } from '@/functions/validation.js';
import { currencyConfig } from '@/functions/validation.js';
export default {
    components: {
        ConfirmCreateCStoPO,
        DownloadReportModal,
        // saveBudgetModal,
        ConfirmApproverCStoPO,
        CancelSaveBudgetList,
        DownloadAttachFile,
    },
    data: () => ({
        callApiPending: 0,
        itemsDataTable: [],
        countTransaction: 0,
        trigRowPerPage: false,
        selectedGroups: {},
        selectedSubGroups: {},
        groupedSubGroup: [],
        selectedItemsConfirm: [],
        listAttachFile: [],
        storedCreateCStoPO: null,
        searchDocumentType: [],
        foundDocumentType: [],
        hasSearched: false,
        searchInput: '',
        windowSize: { x: 0 },
        selectedButton: '',
        TapSearchDocumentType: Number(localStorage.getItem('TapSearchDocumentType') || 0),
        checkQTValueNumber: false,
        checkQTValueNumberOver: false,
        tableHeadersS0: [
            { text: 'Sale Document', align: 'center', value: 'sale_document', width: '150px', class: 'sticky-table--sale-document', cellClass: 'sticky-table--sale-document' },
            { text: 'Document ID', align: 'center', value: 'doc_id', width: '150px', class: 'sticky-table--document-id-so', cellClass: 'sticky-table--document-id-so' },
            { text: 'Job Status', align: 'center', value: 'job_status', width: '300px' },
            { text: 'Terminate Doc', align: 'center', value: 'terminate', width: '150px' },
            { text: 'Terminate Date', align: 'center', value: 'terminate_date', width: '150px' },
            { text: 'Job.Ref', align: 'center', value: 'job_ref_no', width: '300px' },
            { text: 'Group Service', align: 'center', value: 'group_service', width: '170px' },
            { text: 'Service Name', align: 'center', value: 'service_name', width: '350px' },
            { text: 'Unit', align: 'center', value: 'unit', width: '80px' },
            { text: 'Unit Type', align: 'center', value: 'unit_type', width: '80px' },
            { text: 'Start Date', align: 'center', value: 'start_date_filter', width: '90px' },
            { text: 'End Date', align: 'center', value: 'end_date_filter', width: '90px' },

            { text: 'Actual', align: 'center', value: 'actual', width: '100px', class: 'sticky-table--actual-so', cellClass: 'sticky-table--actual-so' },
            { text: 'File', align: 'center', value: 'file', width: '80px', class: 'sticky-table--file-so', cellClass: 'sticky-table--file-so' },
            { text: 'Vendor Name', align: 'center', value: 'vendor', width: '130px', class: 'sticky-table--vendor-name-so', cellClass: 'sticky-table--vendor-name-so' },
            { text: 'QT Vendor', align: 'center', value: 'qt_vender', width: '130px', class: 'sticky-table--qt-vendor-so', cellClass: 'sticky-table--qt-vendor-so' },
            { text: 'QT Value', align: 'center', value: 'qt_value', width: '130px', class: 'sticky-table--qt-value-so', cellClass: 'sticky-table--qt-value-so' },
            { text: 'ส่วนลด', align: 'center', value: 'discount', width: '130px', class: 'sticky-table--discount-so', cellClass: 'sticky-table--discount-so' },
            { text: '', align: 'center', value: 'action', width: '48px', class: 'sticky-table--checkbox-so', cellClass: 'sticky-table--checkbox-so' }
        ],
        tableHeadersCS: [
            { text: 'Document ID', align: 'center', value: 'doc_id', width: '150px', class: 'sticky-table--document-id', cellClass: 'sticky-table--document-id' },
            { text: 'Job Status', align: 'center', value: 'job_status', width: '300px' }, 
            { text: 'Job.Ref', align: 'center', value: 'job_ref_no', width: '300px' },
            { text: 'Group Service', align: 'center', value: 'group_service', width: '170px' },
            { text: 'Service Name', align: 'center', value: 'service_name', width: '350px' },
            { text: 'Unit', align: 'center', value: 'unit', width: '80px' },
            { text: 'Unit Type', align: 'center', value: 'unit_type', width: '80px' },
            { text: 'Start Date', align: 'center', value: 'start_date_filter', width: '90px' },
            { text: 'End Date', align: 'center', value: 'end_date_filter', width: '90px' },
            { text: 'remark', align: 'center', value: 'remark', width: '90px' },

            { text: 'Actual', align: 'center', value: 'actual', width: '80px', class: 'sticky-table--actual', cellClass: 'sticky-table--actual' },
            { text: 'File', align: 'center', value: 'file', width: '80px', class: 'sticky-table--file', cellClass: 'sticky-table--file' },
            { text: 'Vendor Name', align: 'center', value: 'vendor', width: '110px', class: 'sticky-table--vendor-name', cellClass: 'sticky-table--vendor-name' },
            { text: 'QT Vendor', align: 'center', value: 'qt_vender', width: '110px', class: 'sticky-table--qt-vendor', cellClass: 'sticky-table--qt-vendor' },
            { text: 'QT Value', align: 'center', value: 'qt_value', width: '110px', class: 'sticky-table--qt-value', cellClass: 'sticky-table--qt-value' },
            { text: 'ส่วนลด', align: 'center', value: 'discount', width: '110px', class: 'sticky-table--discount', cellClass: 'sticky-table--discount' },
            { text: 'ผู้อนุมัติ', align: 'center', value: 'approver', width: '100px', class: 'sticky-table--approver', cellClass: 'sticky-table--approver' },
            { text: '', align: 'center', value: 'action', width: '48px', class: 'sticky-table--checkbox', cellClass: 'sticky-table--checkbox' }
        ],
        optionsTransaction: { 
            "page": 1,
            "itemsPerPage": 20
        },
        filterData: { 
            "topic" : {
                "text" : null,
                "value" : null
            },
            "keyword" : [],
            "holdKeyword" : []
        },
        itemSearchDropdown: [
            {
                "text" : "None",
                "value" : ""
            },
            {
                "text" : "Document ID",
                "value" : "cs_document_id"
            },
            {
                "text" : "Sale Document",
                "value" : "sale_document"
            },
            {
                "text" : "Group Service",
                "value" : "group_service"
            },
            {
                "text" : "PO",
                "value" : "po_number"
            }
        ],
        vendorList: []
    }),
    watch: {
        "optionsTransaction.page"() {
            this.getCSToPO();
            this.getVendorList()
            this.trigRowPerPage = true;
        },
        "optionsTransaction.itemsPerPage"() {
            if (!this.trigRowPerPage) {
                this.optionsTransaction.page = 1;
                this.getCSToPO();
                this.getVendorList()
            }
        },
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true);
            } else {
                EventBus.$emit('loadingState', false);
            }
        },
        TapSearchDocumentType(val) {
        this.searchDocumentType = []
        this.foundDocumentType = []
        this.hasSearched = false
        this.searchInput = ''
        const tabValue = Number(val)

        localStorage.setItem('TapSearchDocumentType', tabValue)
        this.selectedButton = tabValue === 1? 'CS' : 'SO';
        this.getCSToPO()
    },
        storedCreateCStoPO: {
            handler(val) {
                if (val.data.length) {
                    this.$nextTick(() =>
                        this.$refs.confirmDialog.open(val.data[0], val.action)
                    );
                } else {
                    this.getCSToPO();
                    this.getVendorList()
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.selectedButton = this.TapSearchDocumentType === 1 ? 'CS' : 'SO';
        this.getCSToPO()
        EventBus.$on('afterSaveBudget', this.checkCStoPOStorage);
        EventBus.$on('afterOpenSaveBudgetListModal', this.checkCStoPOStorage);
        this.onResize()
        this.getVendorList()
    },
    beforeDestroy() {
        EventBus.$off('afterSaveBudget');
        EventBus.$off('afterOpenSaveBudgetListModal');
    },
    computed: {
        selectedBiz() {
                return this.$store.state.confirmSelectedBiz
        },
        currentHeaders() {
            return this.selectedButton === 'CS' 
            ? this.tableHeadersCS 
            : this.tableHeadersS0;
        }
    },
    methods: {
        currencyConfig,
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        async getCSToPO() {
            this.callApiPending++;
            this.itemsDataTable = [];
            this.selectedSubGroups = {}
            this.selectedGroups = {}
            this.countTransaction = 0;
          try {
                const isCS = this.selectedButton === 'CS';
              
                const searchUrl = isCS
                    ? '/cs_to_po/api/v1/get_cs'
                    : '/cs_to_po/api/v1/get_cs_to_po';
                const searchValues = Array.isArray(this.searchDocumentType) 
                    ? this.searchDocumentType : [];

                const params = {
                    ...(searchValues.length > 0 && !isCS && {
                        type: this.selectedButton,
                    }),
                    keyword: searchValues.length > 0 ? searchValues.map((e) => (e)) : [],                  
                };

                const searchBody = {
                    ...params,
                    limit: this.searchDocumentType.length > 20 ? this.searchDocumentType.length : this.optionsTransaction.itemsPerPage || 20,
                    page: this.optionsTransaction.page || 1,
                };


                const searchCSToPO = {
                    baseURL: this.$api_url,
                    url: searchUrl,
                    method: 'post',
                    data: searchBody
                };  
                const data = await this.axios(searchCSToPO);
                this.countTransaction = isCS ? data.data.count : +data.data?.count || 0;               
                this.itemsDataTable = data.data.data.map(e => {
                    return {
                        // "number" : e?.document_id || '',
                        // "transaction_id" : e._id || null,
                        // "po" : e?.po_number || '',
                        // "save_budget" : e?.save_budget[0]?._id || '',
                        "sale_document": e?.so_number || null,
                        "open_expanded": 1,
                        // "start_date" : findDate?.p_so_04 || null,
                        // "end_date" : findDate?.p_so_05 || null,
                        "expanded" : e.cs_list.map(e1 => {
                            return {
                                // "sale_document" : e2?.sale_document || '',
                                // "cs_list" : e1?.map(e2 => {
                                //     return {
                                "actual" : MainFunction.addComma(+(+(e1?.actual || '0')).toFixed(2)),
                                "revenue" : MainFunction.addComma(+(e1?.revenue || '0')),
                                "sale_document" : e1?.sale_document || '',
                                "document_id" : e1?.document_id || '',
                                "job_status" : e1?.job_status || '',
                                "terminate" : e1?.terminate || '',
                                "terminate_date" : MainFunction.shortDate(e1?.terminate_date || ''),
                                "job_ref_no" :  e1?.job_ref_no || '',
                                "status_terminate" :  e1?.status_terminate || '',
                                "group_service" : e1?.group_service || '',
                                "service_name" : e1?.service_name || '',
                                "unit" : e1?.unit || '',
                                "unit_type" : e1?.unit_type || '',
                                "qt_vendor" : e1?.qt_vendor || '',
                                "qt_value" : e1?.qt_value || '',
                                "file": "",
                                "from": e1?.from || '',
                                "_id": e1?._id || '',
                                "p_so_04": e1?.p_so_04 || '',
                                "p_so_05": e1?.p_so_05 || '',
                                "approver_cs": isCS ? e1?.approver_cs : '',
                                "start_date_filter": MainFunction.shortDate(e1?.p_so_04 || ''),
                                "end_date_filter": MainFunction.shortDate(e1?.p_so_05 || '')
                                        // "products" : {
                                        //     "item_id" : '',
                                        //     "discount" : "0",
                                        //     "currency_exchange" : "1",
                                        //     "cut_budget_type" : 'ต้นทุนขาย (COGS)',
                                        //     "item_name" : e2.service_name,
                                        //     "total_product_price" : e2.actual
                                        // }
                                //     };
                                // })
                            };
                        })
                    };
                });
        } catch (error) {
            console.log(error);
            this.foundDocumentType = [];
            this.hasSearched = false;
        } finally {
            this.callApiPending--;
            this.trigRowPerPage = false;
            // this.setTemplateTable();
        }
    },
        groupCheckboxChanged(group) {
            this.selectedItemsConfirm = [];
            group.open_expanded = 0;
            if (this.selectedButton === "CS") {
                const expandedItems = Array.isArray(group.expanded) ? group.expanded : [];
                if (!expandedItems.length) {
                    this.updateCheck();
                    return;
                }
                const document_id = group.document_id || expandedItems.find(item => item.document_id)?.document_id || expandedItems.find(item => item.document_id_temp)?.document_id_temp || expandedItems.find(item => item.add_qt?.document_id)?.add_qt?.document_id;
                if (!document_id) {
                    this.updateCheck();
                    return;
                }
                const selectableItems = expandedItems.filter(item => {
                    const approver = item.approver_cs || item.add_qt?.approver_cs;
                    return approver !== undefined && approver !== null && String(approver).trim() !== "" && String(approver).trim() !== "-";
                });
                const isChecked = !!this.selectedGroups[document_id];
                if (isChecked) {
                    selectableItems.forEach(item => {
                        const approver = item.approver_cs || item.add_qt?.approver_cs;
                        this.$set(this.selectedSubGroups, item._id, {
                            ...item,
                            document_id: item.document_id || item.document_id_temp || item.add_qt?.document_id || document_id,
                            checkbox: true,
                            qt_vendor: item.qt_vendor || "",
                            qt_value: item.qt_value || "",
                            vendor: item.vendor || "",
                            approver_cs: approver
                        });
                    });
                } else {
                    selectableItems.forEach(item => {
                        this.$delete(this.selectedSubGroups, item._id);
                    });
                }
                this.updateCheck();
                return;
            }
            const sale_document = group.sale_document || group.sale_document_temp;
            if (!sale_document) {
                this.updateCheck();
                return;
            }
            const groupedItems = this.itemsDataTable.filter(el => el.sale_document === sale_document || el.sale_document_temp === sale_document);
            if (this.selectedGroups[sale_document]) {
                groupedItems.forEach(el => {
                    if (!Array.isArray(el.expanded)) {
                        return;
                    }
                    el.expanded.forEach(ele => {
                        this.$set(this.selectedSubGroups, ele._id, {
                            ...ele,
                            checkbox: true,
                            qt_vendor: ele.qt_vendor || "",
                            qt_value: ele.qt_value || "",
                            vendor: ele.vendor || ""
                        });
                    });
                });
            } else {
                groupedItems.forEach(item => {
                    if (!Array.isArray(item.expanded)) {
                        return;
                    }

                    item.expanded.forEach(element => {
                        this.$delete(this.selectedSubGroups, element._id);
                    });
                });
            }
            this.updateCheck();
        },
        subGroupCheckboxChanged(itemDataTable, subgroup) {
            this.selectedItemsConfirm = [];

            if (this.selectedButton === "CS") {
                const flatData = this.itemsDataTable.reduce((acc, curr) => {
                    if (!Array.isArray(curr.expanded)) {
                        return acc;
                    }

                    return [...acc, ...curr.expanded];
                }, []);

                const currentItem = flatData.find(item => item._id === subgroup._id);

                if (!currentItem) {
                    this.updateCheck();
                    return;
                }

                const document_id = currentItem.document_id || currentItem.document_id_temp || currentItem.add_qt?.document_id || subgroup.document_id || subgroup.document_id_temp || subgroup.add_qt?.document_id;

                if (!document_id) {
                    this.updateCheck();
                    return;
                }

                const approver = currentItem.approver_cs || currentItem.add_qt?.approver_cs;

                const hasApprover = approver !== undefined && approver !== null && String(approver).trim() !== "" && String(approver).trim() !== "-";

                if (!hasApprover) {
                    this.$delete(this.selectedSubGroups, currentItem._id);
                    this.$set(this.selectedGroups, document_id, false);
                    this.updateCheck();
                    return;
                }

                if (this.selectedSubGroups[currentItem._id]) {
                    this.$set(this.selectedSubGroups, currentItem._id, {
                        ...currentItem,
                        document_id: currentItem.document_id || currentItem.document_id_temp || currentItem.add_qt?.document_id || document_id,
                        checkbox: true,
                        qt_vendor: currentItem.qt_vendor || "",
                        qt_value: currentItem.qt_value || "",
                        vendor: currentItem.vendor || "",
                        approver_cs: approver
                    });
                } else {
                    this.$delete(this.selectedSubGroups, currentItem._id);
                }

                const documentItems = flatData.filter(item => {
                    const itemDocumentId = item.document_id || item.document_id_temp || item.add_qt?.document_id;
                    const itemApprover = item.approver_cs || item.add_qt?.approver_cs;
                    const hasApprover = itemApprover !== undefined && itemApprover !== null && String(itemApprover).trim() !== "" && String(itemApprover).trim() !== "-";

                    return itemDocumentId === document_id && hasApprover;
                });

                const allSelected = documentItems.length > 0 && documentItems.every(item => !!this.selectedSubGroups[item._id]);
                this.$set(this.selectedGroups, document_id, allSelected);
                this.updateCheck();
                return;
            }

            const flatData = this.itemsDataTable.reduce((acc, curr) => {
                if (!Array.isArray(curr.expanded)) {
                    return acc;
                }

                return [...acc, ...curr.expanded.map(item => ({ ...item }))];
            }, []);

            const currentItem = flatData.find(item => item._id === subgroup._id);

            if (!currentItem) {
                this.updateCheck();
                return;
            }

            const sale_document = currentItem.sale_document || currentItem.sale_document_temp || currentItem.add_qt?.sale_document || subgroup.sale_document || subgroup.sale_document_temp;

            if (!sale_document) {
                this.updateCheck();
                return;
            }

            if (this.selectedSubGroups[currentItem._id]) {
                this.$set(this.selectedSubGroups, currentItem._id, {
                    ...currentItem,
                    checkbox: true,
                    qt_vendor: currentItem.qt_vendor || "",
                    qt_value: currentItem.qt_value || "",
                    vendor: currentItem.vendor || ""
                });
            } else {
                this.$delete(this.selectedSubGroups, currentItem._id);
            }
            const documentItems = flatData.filter(item => item.sale_document === sale_document || item.sale_document_temp === sale_document);
            const allSelected = documentItems.length > 0 && documentItems.every(item => !!this.selectedSubGroups[item._id]);
            this.$set(this.selectedGroups, sale_document, allSelected);
            this.updateCheck();
        },
        confirmCreateCStoPO(action) {
            this.action = action;
            if (this.checkQTValueNumberOver){
                this.alert(
                    "กรุณากรอก กรอกข้อมูลให้ถูกต้อง",
                    "Warning",
                    "info"
                );
                return
            }
            if (!this.selectedItemsConfirm || this.selectedItemsConfirm.length === 0) {
                this.alert('กรุณาเลือกรายการก่อนยืนยัน', 'Warning', 'info');
                return;
            }
            if (action === "SaveCsToPo" || action === "RunPo") {
                let hasAddQt = false;
                let dateStorage = [];
                let vendorStorage = [];
                let countDuplicatedQtById = [];
                let haveEmptyValue = false
                this.selectedItemsConfirm.forEach(
                    ({ _id, qt_vendor, qt_value, vendor,discount, add_qt, p_so_04, p_so_05 }) => {
                        const start_date = p_so_04 || (add_qt && add_qt.p_so_04) || null;
                        const end_date = p_so_05 || (add_qt && add_qt.p_so_05) || null;
                        const key_date = `${start_date}_${end_date}`;
                        const temp_id = _id.split("___")[0];

                        if (!qt_vendor || !qt_value || !vendor || !discount) {
                            haveEmptyValue = true
                        }
                        if (!dateStorage.includes(key_date)) {
                            dateStorage.push(key_date);
                        }
                        if (!vendorStorage.includes(qt_vendor)) {
                            vendorStorage.push(qt_vendor);
                        }
                        if (!countDuplicatedQtById[temp_id]) {
                            countDuplicatedQtById[temp_id] = 1;
                        } else {
                            hasAddQt = true;
                            countDuplicatedQtById[temp_id] += 1;
                        }
                    }
                );

                if (haveEmptyValue) {
                    this.alert(
                        "กรุณากรอกข้อมูลให้ครบถ้วน",
                        "Warning",
                        "info"
                    );
                    return;
                }

                if (dateStorage.length > 1) {
                    this.alert(
                        "กรุณาเลือกรายการที่มีข้อมูลวันที่เริ่มต้น - วันที่สิ้นสุดตรงกัน",
                        "Warning",
                        "info"
                    );
                    return;
                }
                if (this.selectedButton === "CS") {
                    const firstItem = this.selectedItemsConfirm[0];
                    const checkDiffVendorName = this.selectedItemsConfirm.some(item =>
                        item.vendor?._id !== firstItem?.vendor?._id ||
                        item.qt_vendor !== firstItem?.qt_vendor
                    );
                    if (checkDiffVendorName) {
                        this.alert(
                            "กรุณาเลือก Vendor Name และ QT vendor ให้ตรงกัน",
                            "Warning",
                            "info"
                        );
                        return;
                    }
                }

                if (hasAddQt) {
                    const groupedData = {};
                    let diffVendor = false
                    this.selectedItemsConfirm.forEach((item) => {
                        const { qt_vendor, qt_value, add_qt, vendor,discount } = item;
                        if (!groupedData[qt_vendor]) {
                            groupedData[qt_vendor] = [];
                        }

                        const configTempItem = item?.add_qt
                            ? { ...add_qt, qt_vendor, qt_value, vendor ,discount }
                            : { ...item };
                        configTempItem.is_multi_qt =
                        countDuplicatedQtById[configTempItem._id] > 1 ?? false;
                        if (groupedData[qt_vendor].length) {
                            if (this.selectedButton !== "CS") {
                                const checkDiffVendorName =groupedData[qt_vendor].some( e => configTempItem.vendor?._id !== e.vendor?._id);
                                if (checkDiffVendorName) {
                                    diffVendor = true;
                                }
                            }
                        }
                            groupedData[qt_vendor].push(configTempItem);
                        });
                    if(diffVendor) {
                        this.alert(
                            "กรุณาเลือก Vendor Name ให้ตรงกับ QT vendor เดียวกัน",
                            "Warning",
                            "info"
                            );
                            return;
                    }

                    this.storedCreateCStoPO = {
                        action,
                        data: Object.values(groupedData),
                    };
                    return;
                } else {
                    if (vendorStorage.length > 1) {
                        this.alert(
                            "กรุณาเลือกรายการที่มี QT vendor ตรงกัน",
                            "Warning",
                            "info"
                        );
                        return;
                    }
                if (this.selectedButton === "CS") {
                    const firstItem = this.selectedItemsConfirm[0];
                    const checkDiffVendorName = this.selectedItemsConfirm.some(e =>
                        e.vendor?._id !== firstItem?.vendor?._id ||
                        e.qt_vendor !== firstItem?.qt_vendor
                    );
                    if (checkDiffVendorName) {
                        this.alert(
                            "กรุณาเลือก Vendor Name และ QT vendor ให้ตรงกัน",
                            "Warning",
                            "info"
                        );
                        return;
                    }
                } else {
                        const checkDiffVendorName = this.selectedItemsConfirm.some(
                            e => e.vendor?._id !== this.selectedItemsConfirm[0]?.vendor?._id
                        );

                    if (checkDiffVendorName) {
                        this.alert(
                            "กรุณาเลือก Vendor Name ให้ตรงกับ QT vendor เดียวกัน",
                            "Warning",
                            "info"
                        );
                        return;
                    }
                }
                    this.selectedItemsConfirm = this.selectedItemsConfirm.map(
                        ({ qt_vendor, qt_value, add_qt, vendor,discount, ...item }) => {
                            return {
                                ...(add_qt ?? item),
                                qt_vendor,
                                qt_value: String(qt_value ?? '').replace(/,/g, ''), 
                                vendor,
                                discount: String(discount ?? '').replace(/,/g, ''),
                                is_multi_qt: false,
                            };
                        }
                    );
                    this.$refs.confirmDialog.open(this.selectedItemsConfirm, action);
                }
            } else {
                this.selectedItemsConfirm = this.selectedItemsConfirm.map(
                    ({ qt_vendor, qt_value, add_qt, vendor,discount, ...item }) => {
                        return {
                            ...(add_qt ?? item),
                            qt_vendor,
                            qt_value: String(qt_value ?? '').replace(/,/g, ''), 
                            discount: String(discount ?? '').replace(/,/g, ''),
                            vendor
                        };
                    }
                );
                this.$refs.confirmDialog.open(this.selectedItemsConfirm, action);
            }
        },
        allAreEqual(array) {
            const result = array.every(element => {
                if (element.p_so_04 === array[0].p_so_04 && element.p_so_05 === array[0].p_so_05 && element.qt_vendor === array[0].qt_vendor) {
                    return true;
                }
            });
            return result;
        },
        alert(title = '', text = 'Fail', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text: text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            });
        },
        confirmFilterData() {
            if (!this.$refs.filterTransactionForm.validate()) {
                return 
            }
            this.filterData.keyword = this.filterData.holdKeyword;
            if (this.filterData.topic.value) {
                if (this.optionsTransaction.page > 1) {
                    return this.optionsTransaction.page = 1;
                } else {
                    this.getCSToPO();
                    this.getVendorList()
                }
            }
        },
        clearFilterData() {
            if (this.filterData.keyword.length) {
                this.getCSToPO();
                this.getVendorList()
            }
            this.$refs.filterTransactionForm.resetValidation()
            this.$set(this.filterData, 'keyword', []);
            this.$set(this.filterData, 'holdKeyword', []);
            this.$set(this.filterData, 'topic', {
                "text" : null,
                "value" : null
            });
            this.$refs.searchDropdown.blur();
        },
        setTemplateTable() {
            let timer = 0;
            let tableRows = null;
            const interval = setInterval(() => {
                timer += 1;
                tableRows = document.querySelectorAll('.get-element-tr-create-cspo');
                if (timer >= 30) {
                    clearInterval(interval);
                } else if (tableRows) {
                    clearInterval(interval);
                    const buttonElement = document.querySelectorAll('.expand-header-document-id');
                    const cellHideExpandEl = document.querySelectorAll('.hide-expand-icon');
                    const headerRowTable = document.querySelectorAll('.each-header-row-expand-table');
                    for (let i = 0; i < tableRows.length; i++) {
                        const tempHeight = tableRows[i].clientHeight < 40 ? 40 : tableRows[i].clientHeight;
                        buttonElement[i].style.minHeight = `${tempHeight}px`;
                        for (let j = ((i * 5) + 1); j <= ((i * 5) + 5); j++) {
                            cellHideExpandEl[j - 1].style.minHeight = `${tempHeight}px`;
                        }
                        for (let j = ((i * 4) + 1); j <= ((i * 4) + 4); j++) {
                            headerRowTable[j - 1].style.height = `${tempHeight}px`;
                        }
                    }
                }
            }, 100);
        },
        goToDownloadReport() {
            const aboutReport = {
                url        : this.selectedButton === 'CS' ? '/report/api/v1/export_CS' : '/report/api/v1/export_report_cs_to_po',
                from       : 'create_cs_po',
                typeDocument : this.selectedButton === 'CS' ? 'cs' : 'so'
            }
            EventBus.$emit('openDownloadReportModal', aboutReport);
        },
        openSaveBudget(item) {
            const tempSaveBudget = {
                "type_budget" : "COST",
                "tax_id" : "0107544000094",
                "document_status" : 'W',
                "document_status_permission" : 'W',
                "in_budget" : false,
                "_id" : item._id,
                "start_date" : item.start_date,
                "end_date" : item.end_date,
                "transaction_id" : item.transaction_id,
                "save_budget_id" : item?.save_budget || null,
                "products" : item.expanded.map(e => e.cs_list[0].products),
                "total_price" : MainFunction.addComma(item.expanded.reduce((acc, prev) => {
                    const actual = +(prev.cs_list[0].actual?.replace(/,/g, '') || '0');
                    return acc + (isNaN(actual) ? 0 : actual);
                }, 0))
            };
            // EventBus.$emit('openSaveBudgetModal', tempSaveBudget);
        },
        openCancelSaveBudgetList(data) {
            EventBus.$emit('openSaveBudgetListModal', data);
        },
        openAttachedFileList(data){  
          EventBus.$emit('downloadFileFromCSPO', [], false, data.sale_document !== undefined && data.sale_document !== null && String(data.sale_document).trim() !== '' && String(data.sale_document).trim() !== '-' ? data.sale_document : data._id, data.from, 'cs_to_po')
        },
        handleExpandDocID(index) {
            if (window.innerWidth < 600) {
                return;
            }
            if ([undefined, null, 1].includes(this.itemsDataTable[index].open_expanded)) {
                return;
            }
            let timer = 0;
            let tableRows = null;
            const interval = setInterval(() => {
                timer += 1;
                tableRows = document.querySelectorAll(`.cell-class-expand-table[name="doc_id_${index}"]`);
                if (timer >= 30) {
                    clearInterval(interval);
                } else if (tableRows.length) {
                    clearInterval(interval);
                    const numRows = tableRows.length / 14;
                    for (let row = 0; row < numRows; row++) {
                        let maximumHeight = 45;
                        for (let col = 0; col < 14; col++) {
                            const value = col * numRows + row;
                            maximumHeight = (maximumHeight < tableRows[value].clientHeight) ? tableRows[value].clientHeight : maximumHeight;
                        }
                        for (let col = 0; col < 14; col++) {
                            const value = col * numRows + row;
                            tableRows[value].style.height = `${maximumHeight}px`;
                        }
                    }
                }
            }, 100);
        },
        filterTypeDoc() {
            if (!this.$refs.filterTransactionForm.validate()) {
                return;
            }
            
            this.checkBeforeGetCSToPO()
        },
        async checkBeforeGetCSToPO() {
            const value = typeof this.searchInput === 'string' ? this.searchInput.trim() : ''

            if (value) {
                const values = value.split(/[,\s\n]+/).map(item => item.trim()).filter(Boolean)
                if (!Array.isArray(this.searchDocumentType)) {
                    this.searchDocumentType = []
                }
                values.forEach(item => {
                    this.searchDocumentType.push(item)
                })
                this.searchInput = ''
            }
            this.searchDocumentType = [...new Set(this.searchDocumentType)]
            this.foundDocumentType = []
            this.hasSearched = false

            if (this.optionsTransaction.page === 1) {
                await this.getCSToPO()
                this.setFoundDocumentType()
                this.getVendorList()
            } else {
                this.optionsTransaction.page = 1
            }
        },
        toggleSelectDocType(event) {
            if (!event) {
                this.searchDocumentType =  [];
                this.$refs.filterTransactionForm.resetValidation();
                this.checkBeforeGetCSToPO();
            }
        },
        addAndDeleteQt(indexItem, indexQt, actions) {
    const temp_data_table = {
        ...this.itemsDataTable[indexItem].expanded[indexQt]
    };

    if (actions === "add") {
        const lastIndexQt = this.itemsDataTable[indexItem].expanded.findLastIndex(({ _id }) => _id.split("___")[0] === temp_data_table._id);

        this.itemsDataTable[indexItem].expanded.splice(lastIndexQt + 1, 0, {
            _id: `${temp_data_table._id}___${Math.floor(Math.random() * 9000000) + 1000000}`,
            qt_vendor: null,
            qt_value: null,
            sale_document_temp: temp_data_table.sale_document || "",
            document_id_temp: temp_data_table.document_id || "",
            add_qt: {
                ...temp_data_table
            }
        });
    } else {
        const indexSelectedItemsConfirm = this.selectedItemsConfirm.findIndex(({ _id }) => _id === temp_data_table._id);

        if (indexSelectedItemsConfirm >= 0) {
            this.selectedItemsConfirm.splice(indexSelectedItemsConfirm, 1);
        }

        this.$delete(this.selectedSubGroups, temp_data_table._id);

        this.$nextTick(() => {
            this.itemsDataTable[indexItem].expanded.splice(indexQt, 1);
        });
    }

    this.$nextTick(() => {
        const expandedItems = this.itemsDataTable[indexItem]?.expanded || [];

        let groupKey;

        if (this.selectedButton === "CS") {
            groupKey = temp_data_table?.document_id || temp_data_table?.document_id_temp || temp_data_table?.add_qt?.document_id;
        } else {
            groupKey = temp_data_table?.sale_document || temp_data_table?.sale_document_temp || temp_data_table?.add_qt?.sale_document;
        }

        if (!groupKey) {
            this.updateCheck();
            return;
        }

        if (this.selectedButton === "CS") {
            const selectableItems = expandedItems.filter(item => {
                const approver = item.approver_cs || item.add_qt?.approver_cs;

                return approver !== undefined && approver !== null && String(approver).trim() !== "" && String(approver).trim() !== "-";
            });

            const allSelected = selectableItems.length > 0 && selectableItems.every(item => !!this.selectedSubGroups[item._id]);

            if (actions === "add") {
                if (this.selectedGroups[groupKey]) {
                    const newItems = selectableItems.filter(item => !this.selectedSubGroups[item._id]);

                    newItems.forEach(item => {
                        const approver = item.approver_cs || item.add_qt?.approver_cs;

                        this.$set(this.selectedSubGroups, item._id, {
                            ...item,
                            document_id: item.document_id || item.document_id_temp || item.add_qt?.document_id || groupKey,
                            checkbox: true,
                            qt_vendor: item.qt_vendor || "",
                            qt_value: item.qt_value || "",
                            vendor: item.vendor || "",
                            approver_cs: approver
                        });
                    });
                }

                const updatedAllSelected = selectableItems.length > 0 && selectableItems.every(item => !!this.selectedSubGroups[item._id]);

                this.$set(this.selectedGroups, groupKey, updatedAllSelected);
            } else {
                this.$set(this.selectedGroups, groupKey, allSelected);
            }
        } else {
            const allSelected = expandedItems.length > 0 && expandedItems.every(item => !!this.selectedSubGroups[item._id]);

            this.$set(this.selectedGroups, groupKey, allSelected);
        }

        this.updateCheck();
    });
},
        clearFilterTypeDoc(){
            this.searchDocumentType = []
              nextTick(() => {
                this.getCSToPO()
                this.getVendorList()
            })
        },
        checkCStoPOStorage() {
            if (this.storedCreateCStoPO && this.storedCreateCStoPO.data.length) {
                this.storedCreateCStoPO.data.shift();
            } else {
                this.getCSToPO();
                this.getVendorList()
            }
        },
        async getVendorList() {
            const vendor = await this.axios.get(`${this.$api_url}/vendor_erp/api/v1/vendor_inbox_cs_po?tax_id=${this.selectedBiz.tax_id}&limit=all`)
            this.vendorList = vendor.data.data;
        },
        // onInput(value, itemExpand, field, expandedItems) {
        //     const formatted = filterNumberInput(value);
        //     if (itemExpand[field] === formatted) return;
        //     this.$set(itemExpand, field, formatted);
        //     this.subGroupCheckboxChanged(expandedItems, itemExpand);
        // },
       validateQtAndDiscount,
       updateCheck()  {
        this.selectedItemsConfirm = Object.entries(
                this.selectedSubGroups
            ).map(([key, value]) => {

                const result =
                    validateQtAndDiscount(value);

                return {
                    key,
                    ...value,
                    checkQTValueNumber: result.isInvalid
                };
            });

            this.checkQTValueNumberOver =
                this.selectedItemsConfirm.some(
                    e => e.checkQTValueNumber
                );
        },
        approverDialogOpen(item) {
            this.$refs.approverDialog.open(item);
        },
        handleSearchKeydown(event) {
            const key = event.key;
            if (key === 'Enter' || key === ',' || key === ' ') {
                event.preventDefault();
                event.stopPropagation();
                if (this.searchDocumentType.length > 20) {
                    this.searchInput = '';
                    return;
                }
                const values = (this.searchInput || '')
                    .split(/[,\s]+/)
                    .map(v => v.trim())
                    .filter(Boolean);
                const remaining = 20 - this.searchDocumentType.length;
                const newValues = values.slice(0, remaining);
                this.searchDocumentType.push(...newValues);
                this.searchInput = '';
                if (event.target) {
                    event.target.value = '';
                }
            }
        },
       handleSearchPaste(event) {
            event.preventDefault();
            const text = event.clipboardData.getData('text');
            const values = text
                .split(/[,\s]+/)
                .map(v => v.trim())
                .filter(Boolean);
            const remaining = 20 - this.searchDocumentType.length;
            const newValues = values.slice(0, remaining);
            this.searchDocumentType.push(...newValues);
            this.hasSearched = false;
            this.foundDocumentType = [];
            this.searchInput = '';
        },
        getDocumentChipClass(item) {
            const list = Array.isArray(this.searchDocumentType) ? this.searchDocumentType : []
            if (!this.hasSearched) {
                const count = list.filter(e => e === item).length
                if (count > 1) {
                    return 'chip-orange'
                }
                return 'chip-blue'
            }
            if (Array.isArray(this.foundDocumentType) && this.foundDocumentType.includes(item)) {
                return 'chip-blue'
            }
            return 'chip-red'
        },

        isDuplicateDocument(item) {
            if (!Array.isArray(this.searchDocumentType)) {
                return false
            }
            const count = this.searchDocumentType.filter(e => e === item).length
            return count > 1
        },
        setFoundDocumentType() {
            const isCS = this.selectedButton === 'CS'
            this.foundDocumentType = isCS
                ? this.itemsDataTable.flatMap(item => item.expanded?.map(e => e.document_id) || [])
                : this.itemsDataTable.map(item => item.sale_document)
            this.foundDocumentType = this.foundDocumentType.filter(Boolean)
            this.hasSearched = true
        },
        handleBeforeInput(event) {
            if (event.inputType !== 'insertText') {
                return
            }
            const value = event.data || ''
            if (!/^[a-zA-Z0-9-]+$/.test(value)) {
                event.preventDefault()
                return
            }
            this.hasSearched = false
            this.foundDocumentType = []
        },
        removeDocumentChip(item) {
            const index = this.searchDocumentType.indexOf(item);
            if (index !== -1) {
                this.searchDocumentType.splice(index, 1);
                 if (this.hasSearched && this.searchDocumentType.length > 0){
                     this.getCSToPO();
                }
            }       
            if (this.hasSearched && this.searchDocumentType.length === 0) {
                    this.searchDocumentType = []
                    this.foundDocumentType = []
                    this.hasSearched = false
                    this.searchInput = ''
                    this.getCSToPO();
            }
        }
    }
}  
</script>
<style scoped>
.container {
  padding: 20px 4.51%;
  margin: 0;
  color: #000;
  font-family: 'Noto Sans Thai', sans-serif;
  min-height: 100vh;
  box-sizing: border-box;
}

.card-container {
  border-radius: 23px;
  background: #F1F1F1;
  box-shadow: 0 4px 50px rgba(0, 0, 0, 0.25);
  padding: 15px 18px;
  width: 100%;
  max-width: 100%;
  min-height: calc(100vh - 40px);
  box-sizing: border-box;
}

.selected-menu-mobile {
    justify-self: end;
}

.header-container {
    padding: 0 1.458%;
    display: flex;
    grid-template-columns: auto 210px auto;
}

.header-text {
    font-weight: 700;
    font-size: calc(100% + 0.86vw);
    line-height: 45px;
}

.search-input-dropdown {
    margin-left: 27px;
    border-radius: 10px;
    font-size: 12px;
}

.list-item-dropdown {
    font-size: 10px;
    font-family: 'Noto Sans Thai', sans-serif;
}

.search-input-dropdown >>> .v-input__control > .v-input__slot {
    min-height: auto !important;
    padding: 0 14px;
}

.search-input-dropdown >>> .v-input__control > .v-input__slot > .v-select__slot > .v-label {
    top: unset;
}

.search-input-dropdown >>> .v-input__control > .v-input__slot > .v-select__slot > .v-input__append-inner {
    margin-top: 0;
}


.search-input-cs-so {
    height: auto !important;
    min-height: 32px !important;

    margin: 0 !important;
    padding: 0 !important;
    border-radius: 5px !important;
    font-size: 12px !important;
}

.search-input-cs-so >>> .v-input__control {
    height: auto !important;
    min-height: 32px !important;
    color: #000 !important;
    margin: 0 !important;
    padding: 0 !important;
}

.search-input-cs-so >>> .v-input__slot {
    height: auto !important;
    min-height: 32px !important;

    margin: 0 !important;
    padding: 4px 6px 4px 12px !important;
    border-radius: 5px !important;
    box-sizing: border-box !important;
}

.search-input-cs-so.v-text-field--outlined >>> .v-input__slot {
    height: auto !important;
    min-height: 32px !important;
}

.search-input-cs-so >>> .v-select__slot {
    height: auto !important;
    min-height: 0px !important;

    margin: 0 !important;
    padding: 0 !important;
}

.search-input-cs-so >>> .v-select__selections {
    height: auto !important;
    min-height: 24px !important;
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    flex-wrap: wrap !important;
    overflow: visible !important;

    box-sizing: border-box !important;
}

.search-input-cs-so >>> .v-select__selections input {
    height: 24px !important;
    min-height: 24px !important;
    margin: 0 !important;
    padding: 0 !important;
    font-size: 12px !important;
    line-height: 24px !important;
    box-sizing: border-box !important;
}


.search-input-cs-so >>> input {
    height: 24px !important;
    min-height: 24px !important;
    margin: 0 !important;
    padding: 0 !important;
    font-size: 12px !important;
    line-height: 24px !important;
    box-sizing: border-box !important;
}

.search-input-cs-so >>> .v-chip {
    height: 24px !important;
    min-height: 24px !important;

    margin: 2px !important;
    padding: 0 6px !important;

    font-size: 12px !important;
    line-height: 24px !important;

    box-sizing: border-box !important;

    flex-shrink: 0 !important;
}

.search-input-cs-so >>> .v-chip__content {
    height: 24px !important;
    min-height: 24px !important;

    display: flex !important;
    align-items: center !important;

    font-size: 12px !important;
    line-height: 24px !important;
}


.search-input-cs-so >>> .v-chip__close {
    width: 18px !important;
    height: 18px !important;

    margin-left: 3px !important;

    font-size: 14px !important;
}



.search-input-cs-so >>> .v-input__append-inner {
    width: 20px !important;
    height: 24px !important;
    min-height: 24px !important;
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-sizing: border-box !important;
    flex-shrink: 0 !important;
}

.search-input-cs-so >>> .v-input__icon {
    width: 40px !important; /* ขยายความกว้างกล่องครอบ */
    height: 40px !important; /* ขยายความสูงกล่องครอบ */
    margin: 0 !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.search-input-cs-so >>> .v-input__icon > .v-icon {
    width: 28px !important; /* ขยายความกว้างตัวไอคอน */
    height: 28px !important; /* ขยายความสูงตัวไอคอน */
    margin: 0 !important;
    padding: 0 !important;
    font-size: 24px !important; /* ขยายขนาดตัวไอคอน (ปรับตามต้องการ) */
    line-height: 24px !important;
}

.search-input-cs-so >>> .v-input__icon--clear {
    width: 28px !important;
    height: 28px !important;
    margin: 0 !important;
}

.search-input-cs-so >>> .v-text-field__details {
    display: none !important;
    height: 0 !important;
    min-height: 0 !important;

    margin: 0 !important;
    padding: 0 !important;
}

.search-input-cs-so >>> .v-label {
    top: 0 !important;
    font-size: 12px !important;
    line-height: 24px !important;
    transform: none !important;
}
.search-input-cs-so >>> .v-chip {
    height: 26px !important;
    min-height: 26px !important;
    margin: 3px !important;
    padding: 0 8px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    line-height: 26px !important;
    border-radius: 3px !important;
    box-sizing: border-box !important;
    flex-shrink: 0 !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
    transition: all 0.2s ease;
}

.search-input-cs-so >>> .v-chip {
    height: 26px !important;
    min-height: 26px !important;
    margin: 3px !important;
    padding: 0 8px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    line-height: 26px !important;
    border-radius: 10px !important;
    box-sizing: border-box !important;
    flex-shrink: 0 !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
}
.search-input-cs-so >>> .chip-blue {
    background: linear-gradient(
        135deg,
        #afcce0,
        #bae6fd
    ) !important;
}

.search-input-cs-so >>> .chip-blue .v-chip__content {
    color: #0369a1 !important;
}

.search-input-cs-so >>> .chip-blue .v-chip__close {
    color: #0284c7 !important;
}

.search-input-cs-so >>> .chip-red {
    background: linear-gradient(
        135deg,
        #fecaca,
        #fca5a5
    ) !important;
}

.search-input-cs-so >>> .chip-red .v-chip__content {
    color: #dc2626 !important;
}

.search-input-cs-so >>> .chip-red .v-chip__close {
    color: #dc2626 !important;
}

.search-input-cs-so >>> .chip-orange {
    background: linear-gradient(
        135deg,
        #fed7aa,
        #fdba74
    ) !important;
}

.search-input-cs-so >>> .chip-orange .v-chip__content {
    color: #c2410c !important;
}

.search-input-cs-so >>> .chip-orange .v-chip__close {
    color: #c2410c !important;
}

.search-input-cs-so.v-input--is-disabled {
    opacity: 0.6;
}

.search-document-wrapper {
    width: 100%;
}

.search-limit-text {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: #ff0000;
}

.search-limit-text-2 {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: #000000;
    width: 100%;
    text-align: right;
}

.search-input-cs-so >>> .v-input__icon--append {
    transform: none !important;
    animation: none !important;
}

.search-input-cs-so >>> .v-input__icon--append .v-icon {
    transform: none !important;
    animation: none !important;
}

.download-button-cs-po {
    font-weight: 600 !important;
    font-size: 14px !important;
    letter-spacing: 0 !important;
    padding: 0 20px !important;
    margin-right: 8px;
    box-shadow: none !important;
    border-radius: 50px !important;
}

.download-button-cs-po-small {
    font-weight: 600 !important;
    font-size: 12px !important;
    letter-spacing: 0 !important;
    padding: 0 14px !important;
    margin-right: 6px;
    box-shadow: none !important;
    border-radius: 50px !important;
}

.custom-header-btn:hover {
    background-color: #F1F5F9 !important;
    transition: background-color 0.2s ease;
}

.custom-header-btn:active {
    background-color: #E2E8F0 !important;
}

.v-expansion-panel--active > .custom-header-btn {
    background-color: #EBF5FF !important;
}

.expansion-cs-list >>> .v-expansion-panel,
.expansion-cs-list-action >>> .v-expansion-panel {
    background-color: transparent;
}

.expansion-cs-list >>> .v-expansion-panel::before,
.expansion-cs-list-action >>> .v-expansion-panel::before {
    box-shadow: none;
}

.expansion-cs-list >>> .v-expansion-panel > button > .v-expansion-panel-header__icon,
.expansion-cs-list-action >>> .v-expansion-panel > button > .v-expansion-panel-header__icon {
    margin: 0 auto;
}

.expansion-cs-list >>> .v-expansion-panel > button,
.expansion-cs-list-action >>> .v-expansion-panel > button {
    min-height: 40px;
}

.expansion-cs-list >>> .v-expansion-panel > .v-expansion-panel-content > .v-expansion-panel-content__wrap {
    padding: 12px 0 0;
}

.expansion-cs-list-action >>> .v-expansion-panel > .v-expansion-panel-content > .v-expansion-panel-content__wrap {
    padding: 3px 0 0;
}

.data-table-create-cspo  >>> .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0 !important;
}

.expansion-expanded {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
}

.expansion-expanded  >>> .v-expansion-panel-content {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
}
.expansion-expanded  >>> .v-expansion-panel-content__wrap {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
}

.expansion-expanded .cell-class-expand-table {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    max-width: 100% !important;
    min-height: 44px !important;
    height: 44px !important;
    margin: 0 !important;
    padding: 0 12px !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
}

.expansion-expanded .cell-class-expand-table.v-row {
    margin: 0 !important;
    padding: 0 12px !important;
}

.expansion-expanded-even {
    background-color: #ffffff !important;
}

.expansion-expanded-odd {
    background-color: #f5f5f5 !important;
}

.list-action-menu-toolbar {
    margin-top: 8px;
}

.hide-expand-icon {
    visibility: hidden;
}

.cell-class-expand-table {
    font-weight: 400;
    min-height: 45px;
}

.cell-class-expand-table tbody tr:nth-of-type(even) {
    background: #F8F5F5;
}

.cell-class-expand-table-text-field {
    font-weight: 400;
    height: 20px;
}

.close-expand-icon {
    font-size: 10px;
}

.close-expand-icon >>> .v-expansion-panel-header__icon {
    display: none;
}

.each-header-row-expand-table {
    min-height: 40px !important;
    height: auto;
    line-height: 24px;
    font-size: 12px;
    font-weight: 700;
}

.list-item-action-toolbar {
    border-radius: 5px;
}

.dropdown-menu-action {
    font-size: 10px !important;
    font-weight: 400;
    line-height: 25px !important;
}

.empty-text-table {
    font-size: 10px !important;
    font-weight: 700;
}

.table-row-mobile {
    padding: 8px;
    font-size: 10px;
    font-weight: 700;
    line-height: 28px;
}

.expand-table-mobile >>> .v-expansion-panel {
    background-color: transparent;
}

.expand-table-mobile >>> .v-expansion-panel::before {
    box-shadow: none;
}

.expand-table-mobile >>> .v-expansion-panel > .v-expansion-panel-header {
    padding: 0;
    font-size: 10px;
    font-weight: 700;
    line-height: 30px;
    min-height: auto;
}

.expand-table-mobile >>> .v-expansion-panel > .v-expansion-panel-content > .v-expansion-panel-content__wrap {
    padding: 0;
    font-weight: 500;
}

.vendor-name-autocomplete {
    width: 163.2px;
}

.vendor-name-autocomplete >>> .v-input__append-inner {
    padding-top: 8px;
}

.card-search-cs-po {
    background-color: #F8F7F7 !important;
    padding: 5px;
    max-width: 100%;
    border-radius: 0 10px 10px 10px !important;
}

.card-main-search {
    background-color: #F1F1F1 !important;
    box-shadow: none;
    width: 420px;
    max-width: 100%;
}

.card-main-search :deep(.v-slide-group__wrapper),
.card-main-search :deep(.v-slide-group__container) {
    background: #F1F1F1;
}

.tab-type-search .tab-search {
    border-radius: 10px 10px 0 0;
    background: rgba(228, 227, 227, 0.65);
    margin: 10px 1px 0 0;
    padding: 6px 24px;
    font-weight: 500;
    text-transform: none;
    overflow: hidden;
    transition: background 0.15s;
}

.tab-type-search .v-tab--active {
    background: #1976D2  !important;
    color: #ffffff !important;
    font-weight: 700;
}

.tab-type-search .tab-search:not(.v-tab--active):hover {
    background: #F8F7F7;
    color: #1976D2;
    font-weight: 700;
}

.tab-type-search .tab-search.v-tab--active {
    color: #ffffff !important;
}

.active-menu-toolbar-waitqt {
    color: #000 !important;
}

.active-menu-toolbar-waitqt-mobile {
    background-color: #F1F1F1;
    color: #000 !important;
}

.data-table-create-cspo {
    width: 100%;
    max-width: 100%;
    background-color: #F1F1F1 !important;
    padding-top: 0 !important;
    overflow: hidden !important;
    position: relative;
}

.data-table-create-cspo >>> .v-data-table__wrapper {
    width: 100%;
    height: calc(100vh - 210px);
    overflow-x: auto !important;
    overflow-y: auto !important;
    position: relative;
    isolation: isolate;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    border-radius: 10px !important;
    scrollbar-width: thin;
    scrollbar-color: #C9CED6 transparent;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table {
    width: max-content !important;
    min-width: 100% !important;
    table-layout: auto !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
    border: none !important;
    outline: none !important;
    border-radius: 10px !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > thead > tr > th {
    position: sticky !important;
    top: 0 !important;
    height: 38px !important;
    min-height: 38px !important;
    padding: 0 5px !important;
    background: #1E293B !important;
    color: #FFFFFF !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    white-space: nowrap;
    border: none !important;
    background-clip: padding-box;
    z-index: 30 !important;
    transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > thead > tr > th:first-child {
    border-top-left-radius: 10px !important;
    border-left: 1px solid rgba(203, 213, 225, 0.65) !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > thead > tr > th:last-child {
    border-top-right-radius: 10px !important;
    border-right: 1px solid rgba(203, 213, 225, 0.65) !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > tbody > tr > td {
    color: #000000;
    font-size: 12px;
    font-weight: 700;
    min-height: 30px !important;
    border-top: none !important;
    border-bottom: none !important;
    background-clip: padding-box;
    transition: background-color 0.12s ease;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > tbody > tr > td:first-child {
    border-left: 1px solid rgba(203, 213, 225, 0.65) !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > tbody > tr > td:last-child {
    border-right: 1px solid rgba(203, 213, 225, 0.65) !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 10px !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 10px !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > tbody > tr:nth-child(odd) > td {
    background-color: #F1F1F1 !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > tbody > tr:nth-child(even) > td {
    background-color: #FFFFFF !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > tbody > tr:nth-child(odd):hover > td {
    background-color: #EAEAEA !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper > table > tbody > tr:nth-child(even):hover > td {
    background-color: #F8F5F5 !important;
}

.data-table-create-cspo >>> table > thead > tr > th[class*="sticky-table--"] {
    z-index: 40 !important;
    background: #1E293B !important;
    background-clip: padding-box;
}

.data-table-create-cspo >>> table > tbody > tr > td[class*="sticky-table--"] {
    z-index: 10 !important;
    background-clip: padding-box;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--sale-document,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--sale-document {
    position: sticky !important;
    left: 0 !important;
    width: 150px !important;
    min-width: 150px !important;
    max-width: 150px !important;
    background-clip: padding-box;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--document-id-so,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--document-id-so {
    position: sticky !important;
    left: 150px !important;
    width: 150px !important;
    min-width: 150px !important;
    max-width: 150px !important;
    background-clip: padding-box;
    box-shadow: 7px 0 16px -9px rgba(15, 23, 42, 0.38);
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--checkbox-so,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--checkbox-so {
    position: sticky !important;
    right: 0 !important;
    width: 48px !important;
    min-width: 48px !important;
    max-width: 48px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--discount-so,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--discount-so {
    position: sticky !important;
    right: 48px !important;
    width: 130px !important;
    min-width: 130px !important;
    max-width: 130px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--qt-value-so,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--qt-value-so {
    position: sticky !important;
    right: 178px !important;
    width: 130px !important;
    min-width: 130px !important;
    max-width: 130px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--qt-vendor-so,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--qt-vendor-so {
    position: sticky !important;
    right: 308px !important;
    width: 130px !important;
    min-width: 130px !important;
    max-width: 130px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--vendor-name-so,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--vendor-name-so {
    position: sticky !important;
    right: 438px !important;
    width: 130px !important;
    min-width: 130px !important;
    max-width: 130px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--file-so,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--file-so {
    position: sticky !important;
    right: 568px !important;
    width: 80px !important;
    min-width: 80px !important;
    max-width: 80px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--actual-so,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--actual-so {
    position: sticky !important;
    right: 648px !important;
    width: 100px !important;
    min-width: 100px !important;
    max-width: 100px !important;
    box-shadow: -8px 0 18px -10px rgba(15, 23, 42, 0.42);
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--document-id,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--document-id {
    position: sticky !important;
    left: 0 !important;
    width: 150px !important;
    min-width: 150px !important;
    max-width: 150px !important;
    background-clip: padding-box;
    box-shadow: 7px 0 16px -9px rgba(15, 23, 42, 0.38);
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--checkbox,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--checkbox {
    position: sticky !important;
    right: 0 !important;
    width: 48px !important;
    min-width: 48px !important;
    max-width: 48px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--approver,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--approver {
    position: sticky !important;
    right: 48px !important;
    width: 100px !important;
    min-width: 100px !important;
    max-width: 100px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--discount,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--discount {
    position: sticky !important;
    right: 148px !important;
    width: 110px !important;
    min-width: 110px !important;
    max-width: 110px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--qt-value,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--qt-value {
    position: sticky !important;
    right: 258px !important;
    width: 110px !important;
    min-width: 110px !important;
    max-width: 110px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--qt-vendor,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--qt-vendor {
    position: sticky !important;
    right: 368px !important;
    width: 110px !important;
    min-width: 110px !important;
    max-width: 110px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--vendor-name,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--vendor-name {
    position: sticky !important;
    right: 478px !important;
    width: 110px !important;
    min-width: 110px !important;
    max-width: 110px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--file,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--file {
    position: sticky !important;
    right: 588px !important;
    width: 80px !important;
    min-width: 80px !important;
    max-width: 80px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--actual,
.data-table-create-cspo >>> table > tbody > tr > td.sticky-table--actual {
    position: sticky !important;
    right: 668px !important;
    width: 80px !important;
    min-width: 80px !important;
    max-width: 80px !important;
    box-shadow: -7px 0 12px -9px rgba(15, 23, 42, 0.55);
}

.data-table-create-cspo >>> table > tbody > tr:nth-child(odd) > td[class*="sticky-table--"] {
    background-color: #F1F1F1 !important;
}

.data-table-create-cspo >>> table > tbody > tr:nth-child(even) > td[class*="sticky-table--"] {
    background-color: #FFFFFF !important;
}

.data-table-create-cspo >>> table > tbody > tr:nth-child(odd):hover > td[class*="sticky-table--"] {
    background-color: #EAEAEA !important;
}

.data-table-create-cspo >>> table > tbody > tr:nth-child(even):hover > td[class*="sticky-table--"] {
    background-color: #F8F5F5 !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--document-id,
.data-table-create-cspo >>> table > thead > tr > th.sticky-table--sale-document {
    border-top-left-radius: 10px !important;
}

.data-table-create-cspo >>> table > thead > tr > th.sticky-table--checkbox,
.data-table-create-cspo >>> table > thead > tr > th.sticky-table--checkbox-so {
    border-top-right-radius: 10px !important;
}

.data-table-create-cspo >>> .v-data-table__progress {
    height: 0 !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
    border: none !important;
}

.data-table-create-cspo >>> table,
.data-table-create-cspo >>> th,
.data-table-create-cspo >>> td {
    outline: none !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background: transparent !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper::-webkit-scrollbar-track {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
    background: #C9CED6 !important;
    border: none !important;
    outline: none !important;
    border-radius: 10px !important;
    box-shadow: none !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
    background: #AEB5C0 !important;
}

.data-table-create-cspo >>> .v-data-table__wrapper::-webkit-scrollbar-corner {
    background: transparent !important;
    border: none !important;
}

.approver-name-row {
    width: 100%;
    height: 24px !important;
    min-height: 24px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: visible !important;
    position: relative;
    z-index: 1;
}

.approver-name {
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: 20px;
    line-height: 20px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    position: relative;
    z-index: 2;
}

.approver-name-empty {
    visibility: hidden;
    pointer-events: none;
}

.v-tooltip__content {
    z-index: 999999 !important;
}

.approver-plus-btn {
    color: #72D572 !important;
}

.approver-plus-btn.v-btn--disabled {
    color: #72D572 !important;
    opacity: 1 !important;
}

.approver-plus-btn.v-btn--disabled .v-icon {
    color: #72D572 !important;
    opacity: 1 !important;
}

.text-limit-length {
    display: -webkit-box;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    line-height: 22px;
    min-height: 22px;
    max-height: 66px;
    box-sizing: border-box;
}


@media only screen and (max-width: 75em) {
    .container {
        padding: 0 4.51%;
        margin: 20px 0;
    }

    .data-table-create-cspo >>> table > thead > tr > th[class*="sticky-table--"],
    .data-table-create-cspo >>> table > tbody > tr > td[class*="sticky-table--"] {
        position: static !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        z-index: auto !important;
        width: auto !important;
        min-width: 0 !important;
        max-width: none !important;
        box-shadow: none !important;
    }

    .vendor-name-autocomplete {
        width: 163.2px;
    }

    .vendor-name-autocomplete >>> .v-input__append-inner {
        padding-top: 8px;
    }
}

@media only screen and (max-width: 64em) {
    .header-container {
        grid-template-columns: 240px auto !important;
        row-gap: 12px;
    }

    .toggle-type-doc {
        grid-row: 2;
    }
}

@media only screen and (max-width: 60em) {
    .search-input-dropdown,
    .search-input-text {
        margin-left: unset;
    }

    .download-button-cs-po {
        grid-column: 2 / -1;
        grid-row: 1;
    }

    .search-input-cs-so {
        height: auto !important;
        min-height: 32px !important;

    }

    .search-input-cs-so >>> .v-input__control {
        height: auto !important;
        min-height: 32px !important;

    }

    .search-input-cs-so >>> .v-input__slot {
        height: auto !important;
        min-height: 32px !important;

    }
}

@media only screen and (max-width: 37.5em) {
    .data-table-create-cspo >>> .v-data-table__wrapper {
        height: calc(100vh - 342px);
    }

    .toggle-type-doc {
        grid-column: 1 / 3;
    }
}

@media only screen and (max-width: 30.56em) {
    .data-table-create-cspo >>> .v-data-table__wrapper {
        height: calc(100vh - 360px);
    }
}
</style>